import menu from "./menu";
import { urls } from "../constants";
import { company } from "../company";

const lang = "en";

export default [
  {
    id: "home",
    menuItem: {
      en: {
        url: "/",
        title: "",
      },
    },
    images: [],
    category: "none",

    videos: [
      {
        video: "https://www.youtube.com/embed/RCBQ-ZWO44Y",
        title: "Fab Form on TSX Venture 50",
        splashScreen: "/images/tsx-venture-50-youtube.webp",
      },
    ],
    body: `
            <div>
                <p><a href="/${lang}/${urls.investor.tsx}">Fab-Form Ranks Among Top 50 Performing Companies on the 2023 TSX Venture 50<sup>®</sup></a></p>
            </div>
        `,
    greeting: {
      title: "WELCOME",
      bodyTitle: "40 years of introducing innovative construction products",
      body: `<p>At Fab-Form Industries, our mission is to innovate and lead the construction industry toward sustainable, efficient, and cost-effective solutions. Since our inception, we’ve been committed to developing products that not only enhance the quality and speed of construction but also minimize environmental impact. By replacing traditional materials like wood and steel with advanced, high-strength fabric systems, we’ve revolutionized how foundations are formed and buildings are constructed.</p>
                <p>Our flagship products, such as Fast-Tube and Fastfoot, are designed with both the builder and the environment in mind. These solutions reduce material waste, lower labor costs, and improve site safety, while delivering superior performance. We believe in empowering builders with tools that make their work easier, faster, and more sustainable. At Fab-Form, innovation isn’t just our business—it’s our passion.</p>`,
      image: "/images/rick.jpg",
      imageTitle: "Fab-Form title here",
      imageDesc: "Here is our slogan",
      imageSign: "Sign here",
      contactUsText:
        "WE HAVE BEEN TRANSFORMING THE IDEAS & VISIONS INTO AWARD-WINNING PROJECTS.",
    },
    news: menu.at(-1).articles,
  },
  {
    id: "contact-us",
    menuItem: {
      en: {
        title: "Contact us",
        url: "contact-us",
        metaTitle: "Career Opportunities at Fab-Form Industries - Join Our Team",
        metaDescription: "Explore exciting career opportunities at Fab-Form Industries. Join our innovative team and help us shape the future of construction.",
      },
    },
    images: [],
    category: "none",
    body: `
            <div class="contactUs-wrapper">
                <div class="contactUs--header">
                    <div class="contact_title">${company.name}</div>
                    <div class="contact_phones">
                        <div>${company.address}</div>
                        <div>Phone: ${company.phone} Local: ${company.localPhone}</div>
                        <div><a href=mailto:${company.email} title="Send mail">${company.email}</a></div>
                    </div>
                    <div class="contactUs-wrapper">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2609.1064585786717!2d-122.9693868!3d49.1605875!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x410b83c50d35504b%3A0x25db4b8b451dad51!2sFab-Form%20Industries%20Ltd.!5e0!3m2!1sen!2sca!4v1677112543211!5m2!1sen!2sca" title="Fab Form om the map" width="800" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        `,
  },
  {
    id: "success",
    menuItem: {
      en: {
        title: "Success",
        url: "success",
      },
    },
    images: [],
    images: [],
    category: "none",
    body: `
            <div>
                <h2>Your request successfully submitted!</h2>
                <p><a href="/en">Return to the main page</a></p>
            </div>
        `,
  },
  {
    id: "privatePlacement",
    menuItem: {
      en: {
        url: urls.investor.privatePlacement,
        title: "",
        metaTitle: "Private Placement - Fab-Form Industries",
        metaDescription: "Explore the latest private placement opportunities at Fab-Form Industries, including product developments and subscription agreement details.",
      },
    },
    category: "none",
    images: [
      "/images/private-placement-oct-2017-1.webp",
      "/images/private-placement-oct-2017-2.webp",
    ],
    body: ``,
    articles: [
      {
        title: "Proceeds of Private Placement",
        body: `
                    <div class="page_article">
                        <p>Funds will be used for the design, development and introduction of three new products into world markets:</p>
                        <ul>
                            <li>
                                <div class="page_articleWrapper--inner">
                                    <div class="page_articleBody">
                                        <div>
                                            <a href="/${lang}/${urls.monopour.mpss.overview}">Manufactured Foundation Components</a>: 
                                            Fab-Form has recently rented 3,500 ft2 of adjacent warehouse space for the manufacture of 
                                            foundation components to be sold into the Vancouver housing and condo markets. The patented 
                                            monopour system allows for premanufactured foundation form components to adapt to uneven 
                                            ground by the adjustable side supports and flexible Fastfoot footing formwork. Once local 
                                            manufacturing has been rationalized, it is Fab-Form's intention to franchise this opportunity 
                                            to truss plants across North America.
                                        </div>
                                    </div>
                                    <img class="page_articleImg" alt="Prefab monopour" src="/images/prefab.webp" />
                                </div>

                            </li>
                            <li>
                                <div class="page_articleWrapper--inner">
                                    <div class="page_articleBody">
                                        <div>
                                            <a href="/${lang}/${urls.fastTube.overview}">Fast-Tube CLEAR Column Form</a>: 
                                            Fab-Form has recently re-designed and newly woven the fabric for the Fast-Tube column form. 
                                            The new fabric is clear for visibility of the concrete pour, stronger and stretches less. 
                                            The installation guide and logo is printed on the outside of the fabric. It is Fab-Form's 
                                            intention to have major construction supply houses distribute this product around the globe.
                                        </div>
                                    </div>
                                    <img class="page_articleImg" alt="Fast-Tube Clear" src="/images/fast-tube-clear.webp" />
                                </div>
                            </li>
                            <li>
                                <div class="page_articleWrapper--inner">
                                    <div class="page_articleBody">
                                        <div>
                                            <a href="/${lang}/${urls.zontBracing.components.zat}">ZAT Catwalk Bracket</a>: Fab-Form introduced the Zont 
                                            Bracing System into the ICF industry three years ago. The system has been very successful 
                                            and is now the largest selling ICF brace in the world. Customers have requested a catwalk 
                                            bracket which we have recently developed and proven in the Vancouver market. It is 
                                            Fab-Form's intention to market this product to ICF users around theglobe. This requires 
                                            testing to ensure the bracket meets OSHA and other jurisdictions safety standards.
                                        </div>
                                    </div>
                                    <img class="page_articleImg" alt="Zat bracket" src="/images/zat-244.webp" />
                                </div>
                            </li>
                        </ul>
                    </div>`,
        image: "",
      },
      {
        title: "Subscription Agreement",
        body: `
                    <div class="page_articleWrapper--inner">
                        <div class="page_articleBodyWrapper">
                            <p>To download the <span class="font-bold">Subscription Agreement</span>, click on the image to the image: </p>
                        </div>
                        <a class="page_articleImg" href="/docs/subscription-agreement-oct-2017.pdf" onclick="window.open(this.href,'_blank');return false;">
                            <img alt="Subscription Agreement Oct 2017" src="/images/subscription-agreement.webp"/>
                        </a>
                    </div>
                `,
        image: "",
      },
      {
        title: "Completing the Subscription Agreement",
        body: `
                    <div class="page_article">
                        <p>All subscribers must fill in the personal information on pages A2, A3, A4 and A5. In addition, 
                        they must choose an exemption listed on pages B5 and B6. There are five exemption categories:</p>
                        <ol>
                            <li><span class="font-bold">Accredited Investor</span>: Your net income exceeded $200,000 in each of the 
                            most recent two calendar years or you own more than $1million in cash and securities or your 
                            net assets exceed $5 
                            million:
                                <ul>
                                    <li>Complete page F2 and Schedule 1 of Form 1</li>
                                </ul>
                            </li>
                            <li><span class="font-bold">Friends, Family and Business Associates</span>: The place is must fall into 
                            one of the eleven categories listed on page F4:
                                <ul>
                                    <li>Choose category on page F4;</li>
                                    <li>Complete Schedule 2, Form 1;</li>
                                    <li>If from Saskatchewan, complete Form 3 on page F13;</li>
                                </ul>
                            </li>
                            <li><span class="font-bold">Minimum Investment of $150,000</span>
                                <ul>
                                    <li>Complete page F5;</li>
                                </ul>
                            </li>
                            <li><span class="font-bold">Employee, Executive Officer, Director or Consultant</strong
                                <ul>
                                    <li>Complete page F5;</li>
                                </ul>
                            </li>
                            <li><span class="font-bold">Existing Shareholder (as of 31 October 2017)</span>: Under BC 45-534, current 
                            shareholders can participate up to $15,000. Similar legislation occurs for other provinces 
                            across Canada.
                                <ul>
                                    <li>Complete page F-5.</li>
                                </ul>
                            </li>
                            <li><span class="font-bold">USA Investor</span>
                                <ul>
                                    <li>Complete Form 4 located on page F14 - F17</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                `,
        image: "",
      },
      {
        title: "More Information",
        body: `<div><p>Please email <a href="mailto:privateplacement@fab-form.com">privateplacement@fab-form.com</a> 
                    or call Rick Fearn at 604.596.3278 extension 101. I look forward to sharing our vision with you.</p>
                    <img class="width-100" alt="Rick's Signature" src="/images/rick-signature-white.webp" /></div>`,
        image: "",
      },
    ],
  },
  {
    id: "corporateGovernanceGuidelines",
    menuItem: {
      en: {
        url: urls.investor.corporateGovernanceGuidelines,
        title: "Corporate Governance Guidelines",
      },
    },
    category: "none",
    images: [],
    body: `
            <div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2> I. Introduction</h2>
                        <p>These Corporate Governance Guidelines are established by the Board of Directors to provide a 
                        structure within which our directors and management can effectively pursue 
                        Fab-Form's objectives for the benefit of our stockholders. The Board intends these guidelines to 
                        serve as a flexible framework within which the Board may conduct its business, not as a set of 
                        binding legal obligations. These guidelines should be interpreted in the context of all applicable 
                        laws, Fab-Form's charter documents and other governing legal documents and Fab-Form policies, which 
                        shall prevail in the case of a conflict with these guidelines.</p>
                        <p>The <span style="color: yellow;">importance of an effective Board of Directors</span> to ensure 
                        continued growth and profitability cannot be understated.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2> II. Board Structure and Composition</h2>
                        <ol>
                            <li><span class="font-bold">Size of the Board</span><br />
                            The authorized number of directors will be determined from time to time by resolution of the 
                            Board. As of 30 August 2022, the number is four.</li>
                            <li><span class="font-bold">Board Membership Criteria</span><br />
                            Fab-Form's Nominating and Corporate Governance Committee reviews and makes recommendations to 
                            the Board regarding the composition and size of the Board, determines the relevant criteria 
                            (including any minimum qualifications), and recommends to the Board the slate of nominees for 
                            election at the Annual Meeting of Stockholders or nominees for election to fill interim 
                            vacancies on the Board.</li>
                            <li><span class="font-bold">Director Independence</span><br/>
                            A majority of directors on the Board will be independent as required by the TSX. The Board also 
                            believes that it is often in the best interest of Fab-Form and its stockholders to have non-independent 
                            directors, including current and (in some cases) former members of management, serve as directors. 
                            Each independent director who experiences a change in circumstances that could affect such director's 
                            independence should deliver a notice of such change to Fab-Form's General Counsel.</li>
                            <li><span class="font-bold">Director's Tenure</span><br />
                            Directors are re-elected every three years. The Board does not believe it should establish 
                            term limits because directors who have developed increasing insight into Fab-Form and its 
                            operations over time provide an increasing contribution to the Board as a whole.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>III. Principal Duties of the Board of Directors</h2>
                        <ol>
                            <li><span class="font-bold">To Oversee Management</span><br/>
                            The fundamental responsibility of the Board is to exercise their business judgment to act in 
                            what they reasonably believe to be the best interests of Fab-Form and its 
                            stockholders. It is therefore the duty of the Board to oversee management&rsquo;s performance 
                            to ensure that Fab-Form operates in an effective, efficient and ethical manner.</li>
                            <li><span class="font-bold">To Oversee Management's Strategic Plan</span><br/>
                            The Strategic Plan is the future of the company. This plan should be reviewed and adjusted 
                            according to changing market conditions and industry trends. The new product pipeline forms 
                            part of this strategic plan.</li>
                            <li><span class="font-bold">Risk Oversight</span><br/>
                            Additionally, the Board has responsibility for risk oversight, with reviews of certain areas 
                            being conducted by the relevant board committees. Directors are expected to invest the time 
                            and effort necessary to understand Fab-Form's business and financial strategies and challenges. 
                            A significant risk for a small and growing company is ensuring continuity of management. The 
                            Board must evaluate this risk on a continual basis.</li>
                            <li><span class="font-bold">Attending Board and Committee Meetings</span><br/>
                            The basic duties of the directors include attending Board and committee meetings and actively 
                            participating in Board and committee discussions. Directors are also expected to make themselves 
                            available outside of board meetings for advice and consultation.</li>
                            <li><span class="font-bold">To Select the Chair and Chief Executive Officer</span><br/>
                            The Board will select the chairman of the Board and the chief executive officer in compliance 
                            with Fab-Form's Certificate of Incorporation and Bylaws.</li>
                            <li><span class="font-bold">To Evaluate Management Performance and Compensation</span><br/>
                            Periodically, the Compensation Committee will evaluate the performance of the chief executive 
                            officer and other executive officers and review and approve the compensation plans, policies 
                            and arrangements for such executives. It will also evaluate the compensation plans, policies 
                            and programs for officers and employees to ensure they are appropriate, competitive and properly 
                            reflect Fab-Form's objectives and performance.</li>
                            <li><span class="font-bold">To Review Management Succession Planning</span><br/>
                            The Nominating and Corporate Governance Committee will periodically review the succession planning 
                            for Fab-Form's executive officers, report its findings and recommendations to the Board, and 
                            work with the Board in evaluating potential successors to these executive management positions.</li>
                            <li><span class="font-bold">To Monitor and Manage Potential Conflicts of Interest</span><br/>
                            The Nominating and Corporate Governance Committee is responsible for considering questions of 
                            possible conflicts of interest of Board members and of corporate officers and reviewing actual 
                            and potential conflicts of interest of Board members and corporate officers. The Audit Committee 
                            will review and approve all related party transactions for which audit committee approval is 
                            required by applicable law or the rules of the TSX Venture Stock Market.</li>
                            <li><span class="font-bold">To Ensure the Integrity of Financial Information</span><br/>
                            The Audit Committee assists the Board in oversight of the integrity of Fab-Form's financial 
                            statements, Fab-Form's compliance with legal and regulatory requirements and Fab-Form's internal 
                            accounting and financial controls. The Audit Committee reports to the Board on a regular basis 
                            regarding such oversight.</li>
                            <li><span class="font-bold">To Monitor the Effectiveness of Board Governance Practices</span><br/>
                            The Nominating and Corporate Governance Committee will review and evaluate the effectiveness 
                            of the governance practices under which the Board operates and make changes to these practices 
                            as needed.</li>	
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>IV. Board Procedures</h2> 
                        <p>Directors are expected to prepare for, attend in person, and contribute meaningfully in all 
                        Board and applicable committee meetings in order to discharge their obligations. Consistent with 
                        their fiduciary duties, directors are expected to maintain the confidentiality of the deliberations 
                        of the Board and its committees.</p>
                        <ol>
                            <li><span class="font-bold">Frequency of Board Meetings</span><br/>
                            Regular meetings of the Board shall be held at such times and places as determined by the Board. 
                            There will be at least four regularly scheduled Board meetings each year, but the Board will 
                            meet more often if necessary. Board meetings are in person. Zoom meetings are problematic because 
                            they do not build a "team".</li>
                            <li><span class="font-bold">Responsibilities of Board Chair</span><br/>
                            The Chair shall ensure that an agenda is prepared in advance and sent to all directors. 
                            Concurrently the Chair shall ensure minutes are taken and distributed to all directors.</li>
                            <li><span class="font-bold">Other Commitments</span><br />
                            Each member of the Board is expected to ensure that other existing and future commitments, 
                            including employment responsibilities and service on the boards 
                            of other entities, do not materially interfere with the member's service as director. Board 
                            members should not have more public company memberships 
                            than would allow them to effectively and productively be a member of Fab-Form's board.</li>
                            <li><span class="font-bold">Executive Sessions of Independent Directors</span><br/>
                            TSX rules require independent Board members to regularly meet in executive session. The 
                            independent Board members shall meet regularly in executive session and at other times as 
                            necessary. Committees of the Board may also meet in executive session as necessary.</li>
                            <li><span class="font-bold">Board Access to Management</span><br/>
                            Members of the Board will have access to Fab-Form's management and employees as needed to 
                            fulfill their duties.</li>
                            <li><span class="font-bold">Code of Business Conduct and Ethics</span><br/>
                            Fab-Form has adopted a Code of Business Conduct and Ethics to provide guidelines for the ethical 
                            conduct by directors, officers and employees. The Code of 
                            Business Conduct and Ethics is posted on Fab-Form's website and directors, officers and employees 
                            are expected to be familiar with it and comply with it.</li>
                            <li><span class="font-bold">Engaging Experts</span><br/>
                            In performing its duties, the Board and each committee shall have the authority, at Fab-Form's 
                            expense, to retain, hire, and obtain advice reports or opinions 
                            from internal or external legal counsel and expert advisors, as they may deem necessary or 
                            appropriate, without consulting with, or obtaining approval from, 
                            management of Fab-Form in advance.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>V. Board Committees</h2> 
                        <ol>
                            <li><span class="font-bold">Number and Composition of Committees</span><br />
                            The Board currently has the following standing committees: an Audit Committee, a Nominating 
                            and Corporate Governance Committee, and a Compensation Committee. From time to time the Board 
                            may form a new committee or disband a current committee. Each committee may create one or more 
                            subcommittees, and each subcommittee shall consist of one or more members of the committee. 
                            Each committee complies with the independence and other requirements established by applicable 
                            law and regulations, including BCSC and TSX Venture rules.</li>
                            <li><span class="font-bold">Committee Appointments</span><br />
                            Members of all standing committees are appointed by the Board. The Board determines the exact 
                            number of members and can at any time remove or replace a committee member.</li>
                            <li><span class="font-bold">Committee Proceedings</span><br />
                            The Chair of each committee of the Board will, in consultation with appropriate committee 
                            members and members of management, and in accordance with the committee's charter, determine 
                            the frequency and length of committee meetings and develop the committee's agenda.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>VI Director Orientation and Continuing Education</h2> 
                        <p>Fab-Form provides an orientation program for new directors that includes written materials, 
                        oral presentations, and meetings with senior members of management. 
                        The orientation program is designed to familiarize new directors with Fab-Form's business and 
                        strategy. The Board believes that ongoing education is important 
                        for maintaining a current and effective Board. Accordingly, the Board encourages directors to 
                        participate in ongoing education, as well as participation in 
                        accredited director education programs.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>VII Board Compensation</h2> 
                        <p>The Compensation Committee has the responsibility to review and make recommendations to the 
                        Board with respect to compensation for service as a member of the Board or a Board committee. 
                        Each Board member is paid $5,000 per year.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>VIII Incentivizing Company Personnel</h2> 
                        <p>Fab-Form believes that more closely aligning the interests of our directors, management and 
                        employees with those of our stockholders is important to promote accountability and prudence.</p>
                        <ol>
                            <li><span class="font-bold">Employees as Owners</span><br />
                            Each employee receives a share of yearly profits which is paid in the form of equity shares. 
                            This ensures the employee feels a part of the Company and will work hard to maximize his/her 
                            profits. This is a core principle of the Company.</li>
                            <li><span class="font-bold">Board and CEO Minimum Stock Ownership Requirement</span><br />
                            Each director and our Chief Executive Officer will be required to meet the following minimum 
                            stock ownership requirements: (i) each director shall own shares of Fab-Form stock equal in 
                            value to at least five times the annual cash retainer for directors (exclusive of retainer 
                            amounts for service as lead independent director or as a member or chair of a Board committee); 
                            and (ii) our Chief Executive Officer shall own shares of Fab-Form stock equal in value to at 
                            least six times his/her base salary. Our directors and Chief Executive Officer shall have five 
                            years from the later of (i) March 3, 2015 and (ii) the date each such person assumed his/her 
                            roles at Fab-Form to come into compliance with these ownership requirements. Compliance with 
                            the minimum stock ownership level will be determined on the date when the grace period set 
                            forth above expires, and annually on each December 31 thereafter, by multiplying the number 
                            of shares held by each director and Chief Executive Officer and the average closing price of 
                            those shares during the preceding month.</li>
                            <li><span class="font-bold">Minimum Vesting Period for Time-Based Equity Awards</span><br />
                            No equity award as to which vesting or the lapse of a period of restriction occurs based solely 
                            on the passage of time that is granted to a &ldquo;named executive officer&rdquo; (as defined 
                            by TSX Venture regulations) may vest, or have a period of restriction that lapses, earlier 
                            than six (6) months from the date on which such vesting or lapse commences.</li>
                            <li><span class="font-bold">Post-Vesting Holding Requirement for Equity Awards</span><br />
                            No named executive officer may sell, transfer, pledge, assign, or otherwise dispose of any 
                            shares of Fab-Form stock acquired pursuant to any stock option, restricted stock unit or 
                            other equity award granted by Fab-Form earlier than the date that is six (6) months after the 
                            date on which such award vests or the period of restriction with respect to such award lapses, 
                            as applicable.</li>
                            <li><span class="font-bold">Equity Award Re-pricing</span><br />
                            Except with stockholder approval or as an adjustment made pursuant to certain fundamental 
                            corporate transactions, Fab-Form will not (a) lower or reduce the exercise price of an 
                            outstanding equity award, (b) cancel, exchange or surrender any outstanding equity award in 
                            exchange for cash or another award for the purpose of re-pricing the award; or (c) cancel, 
                            exchange or surrender any outstanding equity award in exchange for an award with an exercise 
                            price that is less than the exercise price of the original award.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>IX Clawback Policy</h2> 
                        <p>The Board shall, in all appropriate circumstances, require reimbursement of any annual incentive 
                        payment or long-term incentive payment to an executive officer of Fab-Form where: (1) the payment 
                        was predicated upon achieving certain financial results that were subsequently the subject of a 
                        financial restatement of Fab-Form's financial statements; and (2) a lower payment would have been 
                        made to the executive based upon the restated financial results.</p>
                        <p>In each such instance, Fab-Form will, to the extent practicable, seek to recover from the 
                        individual executive the amount by which the individual executive&rsquo;s incentive 
                        payments for the relevant period exceeded the lower payment that would have been made based on 
                        the restated financial results.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>X Auditor Rotation</h2> 
                        <p>The Audit Committee will ensure that the lead audit partner and the audit review partner be 
                        rotated every five (5) years as is required by TXS rules.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>XI Communications with Shareholders</h2> 
                        <ol>
                            <li><span class="font-bold">Stockholder Communications to the Board</span><br/>
                                Stockholders may contact the Board to provide comments, to report concerns including issues 
                                related to Fab-Form's accounting practices, internal controls, financial statements or 
                                auditing matters, or to ask questions at the following address:<br />
                                <br/>
                                Corporate Secretary<br/>
                                Fab-Form Industries Ltd.<br/>
                                Unit 19, 1610 Derwent Way<br/>
                                Delta, BC V3M 6W1<br/>
                                Canada
                            </li>
                            <li><span class="font-bold">Annual Meeting of Stockholders</span><br/>
                            Although Fab-Form does not have a formal policy regarding attendance by members of the Board 
                            of Directors at Fab-Form's annual meeting of stockholders, Fab-Form encourages directors to 
                            attend.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>XII Promotion of Common Shares</h2> 
                        <p>The Board has a policy in place that there will be no contracting out of 
                        the promotion of common shares to stock promoters. The Board believes profits and invested capital 
                        is best used to develop and market new products. This will enhance long term growth of sales and 
                        earnings per share.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h2>XIII Periodic Review of the Corporate Governance Guidelines</h2> 
                        <p>These guidelines shall be reviewed periodically by the Nominating and Corporate Governance 
                        Committee and the Board will make appropriate changes based on recommendations from the Nominating 
                        and Corporate Governance Committee.</p>
                        <p style="color: yellow">Reviewed and approved by the board, 22 November 2022</p> 
                    </div>
                </div>
            </div>
        `,
  },
  {
    id: "auditCommitteeCharter",
    menuItem: {
      en: {
        url: urls.investor.auditCommitteeCharter,
        title: "Audit Committee Charter",
        metaTitle: "Audit Committee Charter - Fab-Form Industries",
        metaDescription: "Learn about the role, responsibilities, and structure of Fab-Form Industries' Audit Committee, including its purpose, membership, and duties.",
      },
    },
    category: "none",
    images: [],
    body: `
            <div>
                 <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> I. Purpose</h3>
                        <p>The purpose of the Audit Committee of the Board of Directors shall be to:</p>
                        <ul>
                            <li>Provide oversight of the Company's accounting and financial reporting processes and 
                            the audit of the Company's financial statements;</li>
                            <li>Assist the Board in oversight of (i) the integrity of the Company's financial statements, 
                            (ii) the Company's compliance with legal and regulatory requirements, 
                            (iii) the independent auditor's qualifications, independence and performance, (iv) the 
                            organization and performance of the Company's internal audit function, and (v) 
                            the Company's internal accounting and financial controls; and</li>
                            <li>Provide to the Board such information and materials as it may deem necessary to make the 
                            Board aware of significant financial matters that require the attention of the Board</li>
                        </ul>
                        <p>In furtherance of these purposes, the Audit Committee will undertake those specific duties and 
                        responsibilities listed below and such other duties as the Board may from time to time prescribe.</p>
                        <p>The Audit Committee's responsibility is one of oversight. The members of the Audit Committee 
                        are not employees of the Company, and they do not perform, or represent that they perform, the 
                        functions of management or the independent auditors. The Audit Committee relies on the expertise 
                        and knowledge of management, the internal auditor and the independent registered accounting firm 
                        in carrying out its oversight responsibilities. The management of the Company is responsible for 
                        preparing accurate and complete financial statements in accordance with generally accepted accounting 
                        principles and for establishing and maintaining appropriate accounting principles and financial 
                        reporting policies and satisfactory internal control over financial reporting.</p>
                        <p>The independent registered accounting firm is responsible for auditing the Company's annual 
                        consolidated financial statements and the effectiveness of the Company's internal control over 
                        financial reporting and reviewing the Company's quarterly financial statements. It is not the 
                        responsibility of the Audit Committee to prepare or certify the Company's financial statements 
                        or guarantee the audits or reports of the independent auditors, nor is it the duty of the Audit 
                        Committee to certify that the independent auditor is &quot;independent&quot; under applicable rules. 
                        These are the fundamental responsibilities of management and the independent auditors.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> II. Membership</h3>
                            <p>The Audit Committee members shall be appointed by, and shall serve at the discretion of, 
                            the Board. The Audit Committee shall consist of at least three members of the Board. The Board 
                            may designate one member of the Audit Committee as its chair. The Audit Committee may form and 
                            delegate authority to subcommittees when appropriate. Members of the Audit Committee must meet 
                            the following criteria (as well as any criteria required by the TSX):</p>
                            <ul>
                                <li>The majority of the committee will be an independent in accordance with (i) the audit 
                                committee requirements of the TSX Rules and (ii) the rules of the BCSC;</li>
                                <li>Each member will be able to read and understand fundamental financial statements, in 
                                accordance with the Audit Committee requirements of the TSX;</li>
                                <li>At least one member will have past employment experience in finance or accounting, 
                                requisite professional certification in accounting, or other comparable experience or 
                                background, including a current or past position as a principal financial officer or 
                                other senior officer with financial oversight responsibilities; and</li>
                                <li>At least one member will be an &quot;audit committee financial expert&quot; as defined 
                                in the rules of the TSX-Venture.</li>
                            </ul>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>III. Responsibilities and Duties</h3> 
                        <p>The responsibilities and duties of the Audit Committee shall include:</p>
                        <h4>Review Procedures</h4>
                        <ol>
                            <li>Reviewing the reports of management, internal audit and the independent auditors concerning 
                            the design, implementation and maintenance of the Company's internal controls and procedures 
                            for financial reporting, including meeting periodically with the Company's management, 
                            internal audit and the independent auditors to review their assessment of the adequacy of such 
                            controls and to review before release the disclosure regarding such system of internal controls 
                            required under TSX rules to be contained in the Company's periodic filings and the attestations 
                            or reports by the independent auditors relating to such disclosure;</li>
                            <li>Reviewing and providing oversight of the external audit by (i) reviewing the independent 
                            auditors' proposed audit scope and approach; (ii) discussing with the Company's independent 
                            auditors the financial statements and audit findings, including any significant adjustments, 
                            management judgments and accounting estimates, significant new accounting policies, disagreements 
                            with management and any other required communications described in applicable accounting standards; 
                            (iii) reviewing with the independent auditors the Company's critical accounting policies 
                            and practices, alternative treatments of financial information within generally accepted accounting 
                            principles that have been discussed with management and the treatment recommended by the independent 
                            auditors, and other material written communications between the independent auditors and management; 
                            and (iv) reviewing reports submitted to the audit committee by the independent auditors in accordance 
                            with applicable TSX requirements;</li>
                            <li>Reviewing and approving the annual internal audit project plan and any proposed changes 
                            and reviewing periodic reports summarizing results of the internal audit projects;</li>
                            <li>Reviewing and discussing with management and the independent auditors the annual audited 
                            financial statements and quarterly unaudited financial statements, including the Company's 
                            disclosures under &quot;Management's Discussion and Analysis&quot; prior to filing the Company's 
                            Annual and Quarterly Reports with Sedar;</li>
                            <li>Recommending to the Board, if deemed appropriate, that the audited financial statements 
                            be included in the Company's Annual Report, in accordance with the 
                            rules and regulations of the TSX;</li>
                            <li>Directing the Company's independent auditors to review before filing with 
                            Sedar the Company's interim financial statements included in Quarterly Reports, using professional 
                            standards and procedures for conducting such reviews;</li>
                            <li>Conducting a post-audit review of the financial statements and audit findings, including 
                            any suggestions for improvements provided to management by internal audit or the independent 
                            auditors, and management's response to such suggestions;</li>
                            <li>Reviewing, prior to announcement, Company press releases and other disclosures containing 
                            financial information for the purpose of ensuring that such press releases 
                            and other disclosures properly disclose financial information presented in accordance with 
                            GAAP and, to the extent non-GAAP information is included, adequately disclose how 
                            such non-GAAP information differs from the comparable GAAP information and ensure that disclosure 
                            of such non-GAAP information is not given undue prominence and that such 
                            non-GAAP information does not provide a misleading presentation of the Company's results of 
                            operations or financial condition;</li>
                            <li>Discussing guidelines and policies with respect to risk assessment and risk management 
                            with the Company's management and overseeing financial risk exposures, 
                            including monitoring the Company's financial condition and investments, the integrity of the 
                            Company's financial statements, accounting matters, internal controls over financial reporting, 
                            the independence of the Company's independent auditor, and guidelines and policies with respect 
                            to risk assessment and risk management;</li>
                            <li>Overseeing the Company's annual enterprise business risk assessment, which is conducted 
                            by the internal audit function and which includes review of the primary risks 
                            facing the Company and the Company's associated risk mitigation measures;</li>
                            <li>Reviewing and approving in advance when possible, or ratifying as soon as reasonably 
                            practicable, any related person transactions;</li>
                            <li>Reviewing, in conjunction with counsel, any legal matters that could have a significant 
                            impact on the Company's financial statements;</li>
                            <li>Reviewing insurance coverage;</li>
                            <li>Reviewing its own charter and processes on an annual basis;</li>
                        </ol>
                        <h4>Independent Auditors</h4>
                        <ol>
                            <li>Having sole authority over appointing, compensating and overseeing the work of the 
                            independent auditors (including resolving disagreements between management and the 
                            independent auditors regarding financial reporting) for the purpose of preparing or issuing 
                            an audit report or related work;</li>
                            <li>Reviewing the independence of the outside auditors, including (i) obtaining on a periodic 
                            basis a written statement from the independent auditors regarding relationships and services 
                            with the Company that may impact independence, as defined by applicable standards and TSX 
                            requirements, and discussing with the independent auditors their independence, (ii) presenting 
                            this statement to the Board, and (iii) to the extent there are relationships, monitoring and 
                            investigating them;</li>
                            <li>Receive and review annually a report by the independent auditor describing the firm's 
                            internal quality-control procedures, any material issues raised by the most 
                            recent internal quality-control review, peer review, or PCAOB review, of the independent 
                            auditing firm, or by any inquiry or investigation by governmental or professional authorities, 
                            within the preceding five years, respecting one or more independent audits carried out by the 
                            firm, and any steps taken to deal with any such issues; and any other required reports from 
                            the independent registered public accounting firm;</li>
                            <li>Pre-approving audit and permissible non-audit services provided to the Company by the 
                            independent auditors, except where pre-approval is not required because such 
                            non-audit services are de minimis under the rules of the TSX, in which case subsequent 
                            approval may be obtained. The Audit Committee may delegate to one or more designated 
                            members of the Audit Committee the authority to pre-approve audit and permissible non-audit 
                            services, provided such pre-approval decision is presented to the full Audit 
                            Committee at its scheduled meetings;</li> 
                        </ol>
                        <h4>Internal Audit</h4>
                        <ol>
                            <li>Reviewing and approving the selection of the Company's internal auditor;</li>
                            <li>Reviewing the activities, organizational structure and qualifications of the internal 
                            audit function;</li>
                            <li>Reviewing and approving changes to the internal audit charter;</li>
                            <li>Reviewing periodically with the Company's internal auditor any issues encountered in the 
                            course of the internal audit function's work;</li> 
                        </ol>
                        <h4>Regulatory Compliance</h4>
                        <ol>
                            <li>Overseeing compliance with the requirements of the TSX for disclosure of auditor's services 
                            and audit committee members, member qualifications and activities;</li>
                            <li>Reviewing management's monitoring of compliance with the Foreign Corrupt Practices Act;</li>
                            <li>Providing a report for inclusion in the Company's proxy statement in accordance with the 
                            rules and regulations of the TSX; and</li>
                            <li>Establishing procedures for receiving, retaining and treating complaints received by the 
                            Company regarding accounting, internal accounting controls or auditing matters and procedures 
                            for the confidential, anonymous submission by employees of concerns regarding questionable 
                            accounting or auditing matters.</li> 
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>IV Meetings</h3> 
                        <ol>
                            <li>The Audit Committee shall meet at least once each fiscal quarter. The Audit Committee may 
                            meet either in person or telephonically, and at such times and places as the Audit Committee 
                            determines. The Audit Committee may establish its own meeting schedule, which it shall provide 
                            to the Board. The Audit Committee may invite to its meetings other Board members, Company 
                            management and such other persons as the Audit Committee deems appropriate in order to carry 
                            out its responsibilities.</li>
                            <li>The Audit Committee shall meet separately with the Chief Executive Officer and separately 
                            with the Chief Financial Officer of the Company at such times as it deems appropriate to review 
                            the financial affairs of the Company. The Audit Committee will meet separately with the independent 
                            auditors of the Company and separately with the head of internal audit, at such times as it 
                            deems appropriate, but not less than quarterly.</li>
                            <li>The Audit Committee will maintain written minutes of its meetings, which minutes will be 
                            filed with the minutes of the meetings of the Board.</li>
                            <li>The Audit Committee shall make regular reports to the full Board on the actions and 
                            recommendations of the Audit Committee.</li>
                        </ol>
                        <h4>Compensation</h4> 
                        <ol>
                            <li>Members of the Audit Committee shall receive such fees, if any, for their service as Audit 
                            Committee members as may be determined by the Board in its sole discretion. The fees for 
                            members are $1,000 per annum.</li>
                            <li>Members of the Audit Committee may not receive any compensation from the Company except 
                            the fees that they receive for service as a member of the Board or any committee thereof.</li>
                            <li>The independent auditors shall report directly to the Audit Committee.</li>
                            <li>In addition, the Audit Committee may retain, as appropriate and at the Company's expense, 
                            outside legal, accounting or other advisors to advise or assist the Audit Committee in the 
                            performance of any of the responsibilities and duties set forth above.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>Committee Members</h3> 
                        <ul>
                            <li>Don Russell, Chairman (independent)</li>
                            <li>Nigel Protter (independent)</li>
                            <li>Joey Fearn (not independent)</li>
                        </ul>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <p style="color: yellow">Reviewed and approved by the board, 30 August 2022</p> 
                    </div>
                </div>
            </div>
        `,
  },
  {
    id: "codeBusinessConduct",
    menuItem: {
      en: {
        url: urls.investor.codeBusinessConduct,
        title: "Code of Business Conduct and Ethics",
        metaTitle: "Code of Business Conduct and Ethics - Fab-Form Industries",
        metaDescription: "Read Fab-Form Industries' Code of Business Conduct and Ethics, which outlines our commitment to integrity, compliance with laws, and fair business practices.",
      },
    },
    category: "none",
    images: [],
    body: `
            <div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> I. Introduction</h3>
                        <p>This Code of Business Conduct and Ethics covers a wide range of business practices and procedures. 
                        It does not cover every issue that may arise, but it sets out basic 
                        principles to guide all employees, directors and officers of Fab-Form Industries Ltd. (the "Company"). 
                        All of our employees, directors and officers must conduct themselves 
                        accordingly and seek to avoid even the appearance of improper behavior. Honesty, without exaggeration, 
                        is of paramount importance in this behavior. The Code should also be provided to and followed by 
                        the Company's agents and representatives, including consultants.</p>
                        <p>If a law conflicts with a policy in this Code, you must comply with the law.  If you have any 
                        questions about these conflicts, you should ask your supervisor how to handle the situation.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> II. Compliance with Laws, Rules and Regulations</h3>
                        <p>Obeying the law, both in letter and in spirit, is the foundation on which this Company's ethical 
                        standards are built. All employees must respect and obey the laws of the cities, states and countries 
                        in which we operate. Although not all employees are expected to know the details of these laws, 
                        it is important to know enough to determine when to seek advice from supervisors, managers or other 
                        appropriate personnel.<br/><br/>If requested, the Company will hold information and training sessions 
                        to promote compliance with laws, rules and regulations, including insider-trading laws.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>III. Conflicts of Interest</h3> 
                        <p>A "conflict of interest" exists when a person's private interest interferes, or appears to 
                        interfere, in any way with the interests of the Company. A conflict situation 
                        can arise when an employee, officer or director takes actions or has interests that may make it 
                        difficult to perform his or her Company work objectively and effectively. 
                        Conflicts of interest may also arise when an employee, officer or director, or members of his or 
                        her family, receives improper personal benefits as a result of his or her 
                        position in the Company. Loans to, or guarantees of obligations of, employees and their family 
                        members may create conflicts of interest.</p>
                        <p>It is almost always a conflict of interest for a Company employee to work simultaneously for 
                        a competitor, customer or supplier. You are not allowed to work for a competitor as a consultant 
                        or board member. The best policy is to avoid any direct or indirect business connection with our 
                        customers, suppliers or competitors, except on our behalf.  Conflicts of interest are prohibited 
                        as a matter of Company policy, except under guidelines approved by the Board of Directors. Conflicts 
                        of interest may not always be clear-cut, so if you have a question, you should consult with higher 
                        levels of management or the Company's Legal Department.  Any employee, officer or director who 
                        becomes aware of a conflict or potential conflict should bring it to the attention of a supervisor, 
                        manager or other appropriate personnel or consult the procedures described in Section 14 of this Code.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>IV Insider Trading</h3>
                        <p>Employees who have access to confidential information are not permitted to use or share that 
                        information for stock trading purposes or for any other purpose except the conduct of our business. 
                        All non-public information about the Company should be considered confidential information. To 
                        use non-public information for personal financial benefit or to "tip" others who might make an 
                        investment decision on the basis of this information is not only unethical but also illegal. In 
                        order to assist with compliance with laws against insider trading, the Company has adopted a 
                        specific policy governing employees' trading in securities of the Company. This policy has been 
                        distributed to every employee.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>V Corporate Opportunities</h3>
                        <p>Employees, officers and directors are prohibited from taking for themselves personally 
                        opportunities that are discovered through the use of corporate property, information or position 
                        without the consent of the Board of Directors. No employee may use corporate property, information, 
                        or position for improper personal gain, and no employee may compete with the Company directly or 
                        indirectly.  Employees, officers and directors owe a duty to the Company to advance its legitimate 
                        interests when the opportunity to do so arises.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>VI Competition and Fair Dealing</h3>
                        <p>We seek to outperform our competition fairly and honestly. Stealing proprietary information, 
                        possessing trade secret information that was obtained without the owner's consent, or inducing 
                        such disclosures by past or present employees of other companies is prohibited. Each employee, 
                        officer and director should endeavor to respect the rights of and deal fairly with the Company's 
                        customers, suppliers, competitors and employees. No employee, officer or director should take 
                        unfair advantage of anyone through manipulation, concealment, abuse of privileged information, 
                        misrepresentation of material facts, or any other intentional unfair-dealing practice.</p>
                        <p>The purpose of business entertainment and gifts in a commercial setting is to create good will 
                        and sound working relationships, not to gain unfair advantage with customers. No gift or 
                        entertainment should ever be offered, given, provided or accepted by any Company employee, 
                        family member of an employee or agent unless it: (1) is not a cash gift, (2) is consistent with 
                        customary business practices, (3) is not excessive in value, (4) cannot be construed as a bribe or 
                        payoff and (5) does not violate any laws or regulations. Please discuss with your supervisor any 
                        gifts or proposed gifts which you are not certain are appropriate.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>VII Discrimination and Harassment</h3>
                        <p>The diversity of the Company's employees is a tremendous asset.  We are firmly committed to 
                        providing equal opportunity in all aspects of employment and will not tolerate any illegal 
                        discrimination or harassment of any kind. Examples include derogatory comments based on racial or 
                        ethnic characteristics and unwelcome sexual advances.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>VIII Health and Safety</h3>
                        <p>The Company strives to provide each employee with a safe and healthy work environment. Each 
                        employee has responsibility for maintaining a safe and healthy workplace for all employees by 
                        following safety and health rules and practices and reporting accidents, injuries and unsafe equipment, 
                        practices or conditions.<br/><br/>Violence and threatening behavior are not permitted. Employees 
                        should report to work in condition to perform their duties, free from the influence of illegal 
                        drugs or alcohol. The use of illegal drugs in the workplace will not be tolerated.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>IX Record Keeping</h3>
                        <p>The Company requires honest and accurate recording and reporting of information in order to 
                        make responsible business decisions. For example, only the true and actual number of hours worked 
                        should be reported.</p>
                        <p>Many employees regularly use business expense accounts, which must be documented and recorded 
                        accurately. If you are not sure whether a certain expense is legitimate, ask your supervisor or 
                        your controller.All of the Company's books, records, accounts and financial statements must be 
                        maintained in reasonable detail, must appropriately reflect the Company's transactions and must 
                        conform both to applicable legal requirements and to the Company's system of internal controls. 
                        Unrecorded or "off the books" funds or assets should not be maintained unless permitted by applicable 
                        law or regulation.</p>
                        <p>Business records and communications often become public, and we should avoid exaggeration, 
                        derogatory remarks, guesswork, or inappropriate characterizations 
                        of people and companies that can be misunderstood. This applies equally to e-mail, internal memos, 
                        and formal reports. Records should always be retained or destroyed according to the Company's 
                        record retention policies. In accordance with those policies, in the event of litigation or 
                        governmental investigation please consult the Company's Legal Department.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>X Confidentiality</h3>
                        <p>Employees, officers and directors must maintain the confidentiality of confidential information 
                        entrusted to them by the Company or its customers, except when disclosure is authorized by the 
                        Legal Department or required by laws or regulations. Confidential information includes all non-public 
                        information that might be of use to competitors, or harmful to the Company or its customers, if 
                        disclosed. It also includes information that suppliers and customers have entrusted to us. The 
                        obligation to preserve confidential information continues even after employment ends.  In connection 
                        with this obligation, every employee should have executed a confidentiality agreement when he or 
                        she began his or her employment with the Company.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>XI Protection and Proper Use of Company Assets</h3>
                        <p>All employees, officers and directors should endeavor to protect the Company's assets and ensure 
                        their efficient use. Theft, carelessness, and waste have a direct impact on the Company's profitability. 
                        Any suspected incident of fraud or theft should be immediately reported for investigation. Company 
                        equipment should not be used for non-Company business, though incidental personal use may be permitted.</p>
                        <p>The obligation of employees to protect the Company's assets includes its proprietary information. 
                        Proprietary information includes intellectual property such as trade secrets, patents, trademarks, 
                        and copyrights, as well as business, marketing and service plans, engineering and manufacturing ideas, 
                        designs, databases, records, salary information and any unpublished financial data and reports. 
                        Unauthorized use or distribution of this information would violate Company policy. It could also 
                        be illegal and result in civil or even criminal penalties.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>XII Reporting any Illegal or Unethical Behavior</h3>
                        <p>Employees are encouraged to talk to supervisors, managers or other appropriate personnel about 
                        observed illegal or unethical behavior and when in doubt about the best course of action in a 
                        particular situation. It is the policy of the Company not to allow retaliation for reports of misconduct 
                        by others made in good faith by employees. Employees are expected to cooperate in internal investigations 
                        of misconduct.<br/><br/>Any employee may submit a good faith concern regarding questionable accounting or 
                        auditing matters without fear of dismissal or retaliation of any kind.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>XIII Compliance Procedures</h3>
                        <p>We must all work to ensure prompt and consistent action against violations of this Code. However, 
                        in some situations it is difficult to know if a violation has occurred. Since we cannot anticipate 
                        every situation that will arise, it is important that we have a way to approach a new question or 
                        problem. These are the steps to keep in mind:</p>
                        <ul>
                            <li>Make sure you have all the facts - In order to reach the right solutions, we must be as 
                            fully informed as possible.</li>
                            <li>Ask yourself:  What specifically am I being asked to do?  Does it seem unethical or improper? 
                            This will enable you to focus on the specific question you are faced with, and the alternatives 
                            you have. Use your judgment and common sense - if something seems unethical or improper, it 
                            probably is.</li>
                            <li>Clarify your responsibility and role - In most situations, there is shared responsibility.</li>
                            <li>Are your colleagues informed?  It may help to get others involved and discuss the problem.</li>
                            <li>Discuss the problem with your supervisor. This is the basic guidance for all situations. 
                            In many cases, your supervisor will be more knowledgeable about the question, and will appreciate 
                            being brought into the decision-making process. Remember that it is your supervisor's responsibility 
                            to help solve problems.</li>
                            <li>Seek help from Company resources - In the rare case where it may not be appropriate to discuss 
                            an issue with your supervisor, or where you do not feel comfortable 
                            approaching your supervisor with your question, discuss it locally with your office manager 
                            or your Human Resources manager.</li>
                            <li>You may report ethical violations in confidence and without fear of retaliation. 
                            - If your situation requires that your identity be kept secret, your anonymity will be protected. 
                            The Company does not permit retaliation of any kind against employees for good faith reports 
                            of ethical violations.</li>
                            <li>Always ask first, act later - If you are unsure of what to do in any situation, seek guidance 
                            before you act.</li>
                        </ul>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>XIV Code of Ethics for CEO and Senior Financial Officers</h3>
                        <p>The Company has a Code of Business Conduct and Ethics applicable to all directors and employees 
                        of the Company. The CEO and all senior financial officers, including the CFO and principal accounting 
                        officer, are bound by the provisions set forth therein relating to ethical conduct, conflicts of 
                        interest and compliance with law. In addition to the Code of Business Conduct and Ethics, the CEO 
                        and senior financial officers are subject to the following additional specific policies:</p>
                        <ol>
                            <li>The CEO and all senior financial officers are responsible for full, fair, accurate, timely 
                            and understandable disclosure in the periodic reports required to be filed by the Company with 
                            the TSX. Accordingly, it is the responsibility of the CEO and each senior financial officer 
                            promptly to bring to the attention of the Disclosure Committee any material information of 
                            which he or she may become aware that affects the disclosures made by the Company in its 
                            public filings or otherwise assist the Disclosure Committee in fulfilling its responsibilities 
                            as specified in the Company's Disclosure Controls and Procedures Policy.</li>
                            <li>The CEO and each senior financial officer shall promptly bring to the attention of the 
                            Disclosure Committee and the Audit Committee any information he or she may have concerning (a) 
                            significant deficiencies in the design or operation of internal controls which could adversely 
                            affect the Company's ability to record, process, summarize and report financial data or (b) 
                            any fraud, whether or not material, that involves management or other employees who have a 
                            significant role in the Company's financial reporting, disclosures or internal controls.</li>
                            <li>The CEO and each senior financial officer shall promptly bring to the attention of the 
                            General Counsel or the Legal Department or the CEO and to the Audit Committee any information 
                            he or she may have concerning any violation of the Company's Code of Business Conduct and 
                            Ethics, including any actual or apparent conflicts of interest between personal and professional 
                            relationships, involving any management or other employees who have a significant role in the 
                            Company's financial reporting, disclosures or internal controls.</li>
                            <li>The CEO and each senior financial officer shall promptly bring to the attention of the 
                            General Counsel or the Legal Department or the CEO and to the Audit Committee any information 
                            he or she may have concerning evidence of a material violation of the securities or other laws, 
                            rules or regulations applicable to the Company and the operation of its business, by the Company 
                            or any agent thereof, or of violation of the Code of Business Conduct and Ethics or of these 
                            additional procedures.</li><li>The Board of Directors shall determine, or designate appropriate 
                            persons to determine, appropriate actions to be taken in the event of violations of the Code 
                            of Business Conduct and Ethics or of these additional procedures by the CEO and the Company's 
                            senior financial officers. Such actions shall be reasonably designed to deter wrongdoing and 
                            to promote accountability for adherence to the Code of Business 
                            Conduct and Ethics and to these additional procedures, and shall include written notices to 
                            the individual involved that the Board has determined that there has been a violation, censure 
                            by the Board, demotion or re-assignment of the individual involved, suspension with or without 
                            pay or benefits (as determined by the Board) and termination of the individual's employment. 
                            In determining what action is appropriate in a particular case, the Board of Directors or such 
                            designee shall take into account all relevant information, including the nature and severity 
                            of the violation, whether the violation was a single occurrence or repeated occurrences, whether 
                            the violation appears to have been intentional or inadvertent, whether the individual in question 
                            had been advised prior to the violation as to the proper course of action and whether or not 
                            the individual in question had committed other violations in the past.</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <p>Committee Members:</p>
                        <ol>
                            <li>Rick Fearn, CEO</li>
                            <li>Joey Fearn, COO</li>
                            <li>Don Russell, Independent</li>
                            <li>Nigel Protter, Independent</li>
                        </ol>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <p style="color: yellow">Reviewed and approved by the board, 30 August 2022</p> 
                    </div>
                </div>
            </div>
        `,
  },
  {
    id: "compensationCommitteeCharter",
    menuItem: {
      en: {
        url: urls.investor.compensationCommitteeCharter,
        title: "Compensation Committee Charter",
        metaTitle: "Compensation Committee Charter - Fab-Form Industries",
        metaDescription: "Explore the Compensation Committee Charter for Fab-Form Industries, outlining responsibilities, authority, and the structure of the committee overseeing executive compensation and employee benefit plans.",
      },
    },
    category: "none",
    images: [],
    body: `
            <div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> I. Purpose</h3>
                        <p>The purpose of the Compensation Committee of the Board of Directors (the "<span class="font-bold">Board</span>") 
                        of Fab-Form Industries Ltd. (the "<span class="font-bold">Company</span>") shall be to discharge the Board's 
                        responsibilities relating to the compensation of the Company's executive officers and the 
                        administration of the Company's employee benefit plans.</p>
                        <p>The Committee shall assist the Board in administering and overseeing (i) the Company's 
                        compensation policies, plans and benefit programs, (ii) the compensation of the Company's 
                        executive officers and (iii) the administration of the Company's employee benefit plans.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3> II. Membership</h3>
                        <p>The Compensation Committee members will be appointed by, and will serve at the discretion of, 
                        the Board. The Compensation Committee will consist of at least two non-employee members of the 
                        Board.</p>
                        <p>Members to be paid $500 per annum.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>III. Responsibilities and Authority</h3> 
                        <p>The responsibilities and authority of the Compensation Committee shall include such responsibilities 
                        and authority delegated by the Board and the following:</p>
                        <ul>
                            <li>Recommending to the Board a compensation philosophy designed to help the Company compete 
                            with other businesses in the Company's industries for the talent that the Company needs;</li>
                            <li>Making recommendations to the Board with respect to the Chief Executive Officer's (1) annual 
                            base salary, (2) bonus arrangements, if any, (3) equity compensation, (4) any employment agreement, 
                            severance arrangement or change in control arrangement, and (5) any other benefits, compensation 
                            or arrangements, based on an evaluation of his or her performance and other relevant criteria 
                            as determined by the Compensation Committee;</li>
                            <li>In consultation with the Chief Executive Officer, reviewing the compensation arrangements 
                            of the other executive officers with respect to (1) annual base salary, (2) bonus arrangements, 
                            if any, (3) equity compensation, (4) any employment agreement, severance arrangement or change 
                            in control arrangement, and (5) any other benefits, compensation or arrangements;</li>
                            <li>Making recommendations to the Board with respect to compensation for service as a member 
                            of the Board or a Board committee;</li><li>Making recommendations to the Board with respect 
                            to all forms of compensation plans;</li><li>Having the sole authority to retain and terminate 
                            any compensation consultant to be used by the Company to assist in the evaluation of executive 
                            officer compensation and having sole authority to approve the consultant's fees and other 
                            retention terms. The Compensation Committee shall also have authority to obtain advice and 
                            assistance from internal or external legal, compensation, accounting or other advisors;</li>
                            <li>Overseeing the administration of material employee benefit plans of the Company, including 
                            the Company's equity plans and benefit plans;</li>
                            <li>Reviewing its own charter, structure, processes and membership requirements.</li>
                        </ul>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>IV Meetings</h3>
                        <p>The Compensation Committee will meet separately as necessary to fulfill its responsibilities 
                        under this Charter. The Compensation Committee may establish its own schedule, which it will 
                        provide to the Board.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>V Minutes and Reports</h3>
                        <p>The Compensation Committee may maintain written minutes of its meetings as it deems appropriate, 
                        which minutes (if any) will be filed with the minutes of the meetings of the Board.</p>
                        <p>The Compensation Committee will summarize its examinations and recommendations to the Board 
                        as may be appropriate, consistent with the Compensation Committee's charter.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>VI Delegation of Authority</h3>
                        <p>The Compensation Committee may form and delegate authority to one or more subcommittees where 
                        appropriate.</p>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <h3>Members</h3>
                        <ul>
                            <li>Nigel Protter</li>
                            <li>Don Russell</li>
                        </ul>
                    </div>
                </div>
                <div class="page_articleWrapper">
                    <div class="page_articleBodyWrapper">
                        <p style="color: yellow">Reviewed and approved by the board, 30 August 2022</p>
                    </div>
                </div>
            </div>
        `,
  },
  {
    id: "marketingMaterials",
    menuItem: {
      en: {
        url: urls.fastFoot.residential.marketingMaterials,
        title: "Marketing Materials",
        metaTitle: "Marketing Materials - Fastfoot®",
        metaDescription: "Access Fastfoot® marketing materials including brochures, point-of-sale displays, banners, rising damp countertop displays, and dealer binders. Download PDFs and explore various promotional resources.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    articles: [
      {
        title: "Fastfoot<sup>®</sup> Brochure",
        body: `
                    <div id="brochure">
                        <p>Four color brochure, printed both sides, tri-folded to a finished size of 4" by 9". The brochure 
                        details the advantages of Fastfoot<sup>®</sup>, explains rising damp, and features Ram Construction's large 
                        warehouse project in Surrey, BC.</p>
                        <p><a href="/docs/fastfoot-brochure.pdf" onclick="window.open(this.href,'_blank');return false;">Download the PDF file.</a></p>
                    </div>
                `,
        image: "/images/fastfoot-brochure.webp",
      },
      {
        title: "Point of Sale Display",
        body: `
                    <div id="posDisplay">
                        <ul>
                            <li>Full color coroplast poster board</li>
                            <li>Brochure holder</li>
                            <li>Dowel to hold Fastfoot<sup>®</sup> upright</li>
                            <li>Size: 29" wide, 12" deep, 32" high</li>
                            <li>Weight: 12 pounds;</li>
                        </ul>
                    </div>
                `,
        image: "/images/pos-display.webp",
      },
      {
        title: "Outdoor Banner",
        body: `
                    <div id="banner">
                        <ul>
                            <li>Vinyl full color banner</li>
                            <li>4 attachment anchors for each corner</li>
                            <li>QR code for easy web access</li>
                            <li>Size: 35.5" wide, 24" high</li>
                            <li>Weight: 1.2 pounds</li>
                        </ul>
                    </div>
                `,
        image: "/images/fastfoot-banner.webp",
      },
      {
        title: "Rising Damp Countertop Display",
        body: `
                    <div id="risingDampDisplay">
                        <ul>
                            <li>Two concrete samples, one protected with Fastfoot<sup>®</sup></li>
                            <li>1/2" thickness of pea gravel</li>
                            <li>Brochure holder</li>
                            <li>Size: 12" wide, 6" deep, 7" high</li>
                            <li>Weight: 2 pounds, including gravel.</li>
                        </ul>
                    </div>
                `,
        image: "/images/rising-damp-display.webp",
      },
      {
        title: "Fastfoot<sup>®</sup> Dealer Binder",
        body: `
                    <div id="dealerBinder">
                        <p>Ten full color pages featuring projects across Canada and the USA.</p>
                        <p><a href="/docs/fastfoot-dealer-binder.pdf" onclick="window.open(this.href,'_blank');return false;">Download the PDF file.</a></p>
                    </div>
                `,
        image: "/images/binder-cover-page.webp",
      },
    ],
  },
  {
    id: "understandingFoldLineLocation",
    menuItem: {
      en: {
        title: "Understanding Fold Line Location",
        url: urls.monopour.mpss.foldLineLocation,
        metaTitle: "Understanding Fold Line Location - Monopour",
        metaDescription: "Learn about fold line location determination in fabric forms, hoop tension, monopour lift heights, and concrete consumption. Download related Excel spreadsheets and explore the hydraulic pressure effects.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    articles: [
      {
        title: "Fold line location determination",
        doc: "/docs/QIM Off-Set = 8.xls",
        body: `
                    <div class="page_article">
                        <p>The determination of the shape of a fabric form under hydraulic pressure requires the resolution 
                        of an equation with five variables. The solution is found recursively and can be seen in the image 
                        below where the height of the concrete footing (12") is found in over 5,000 lines of the Excel 
                        spreadsheet. In this case the contact width is 8". The spread sheet calculates the fabric upper 
                        length of 22.18". The bottom edge of the ICF block is located at 0 on the "X" axis and 12" on the "Y" axis.</p>
                        <h3 class="page_articleTitle">Hoop tension in fabric</h3>
                        <p>The Excel program also determines the hoop tension in the fabric induced by the hydraulic pressure 
                        of the concrete (in this case 4.848 pounds per lineal inch of fabric). If the fabric is attached 
                        with a plywood batten with screws 8" on centre, the pressure on each screw will be 4.848 lbs. x 8" = 
                        38.8 lbs., well within the pullout strength a screw in a typical ICF web.</p>
                        <h3 class="page_articleTitle">Monopour lift heights</h3>
                        <p>In the example shown below, the height of the concrete poured into the stem wall is 15.5", 
                        30% greater than the footing height of 12". When monopouring it is <span style="color:yellow">
                        extremely important</span> that the first lift fills up the footing and part of 
                        the first block, and the concrete is then allowed to "go-off". If the concrete height is excessive 
                        and if vibration is encouraged, the concrete in the wall will attempt to blow up the bag and lift 
                        the form. You can easily see when this is about to occur as the angle of the fabric by the plywood 
                        batten will be greater than 90 degrees.</p>
                        <p>If you wish to download the Excel spread sheet, click on the image.</p>
                    </div>
                `,
        image: "/images/calculation-of-fold-distance.webp",
      },
      {
        title: "Concrete consumption",
        body: `
                    <div class="page_article">
                        <p>As can be seen in the curve in the image below, concrete is wasted in the bulge area, and saved 
                        by in the sloped region on the upper edge of the footing. Concrete is also saved as you pour into 
                        a closed form, hence no leakage. When ordering concrete it is best to assume concrete 
                        consumption is the same as with a rectangular shaped footing.</p>
                    </div>
                `,
        image: "/images/mp-graphics-xsection.webp",
      },
    ],
  },
  {
    id: "fastfootMpManufacture",
    menuItem: {
      en: {
        url: urls.monopour.mpss.fastfootMpManufacture,
        title: "Fastfoot MP Manufacture",
        metaTitle: "Fastfoot MP Manufacture - Foundation Components and Installation",
        metaDescription: "Learn about the Fastfoot MP manufacturing process, including pre-built foundation components, glueing ICF blocks, attaching side supports, and installing Fastfoot®. Access tools, materials, and calculator for accurate component design.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    articles: [
      {
        title: "Pre-build Foundation Components",
        body: `
                    <div class="page_article">
                        <p>There are two types of foundations components:</p>
                        <ul>
                            <li>ICF components three blocks long & two blocks high;</li>
                            <li>Door buck components (located at the footing level);</li>
                        </ul>
                        <p>This section describes the gluing of blocks into components, so they can withstand the loads 
                            caused by Fastfoot<sup>®</sup>. This can be done offsite in a warehouse or onsite using a flat working area.</p>
                        <p><a href="/${lang}/${urls.monopour.mpss.doorBuck}">Design and construction of door bucks</a>.</p>
                        <p>There are four steps:</p>
                            <ol>
                                <li><a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">Determine the number and size of foundation components, 
                                including door and window bucks;</a></li>
                                <li><a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">Glue ICF blocks into components;</a></li>
                                <li><a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">Attach Side Supports;</a></li>
                                <li><a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">Attach Fastfoot<sup>®</sup>;</a></li>
                            </ol>
                        <p><a href="/${lang}/${urls.monopour.mpss.installation}">Site installation</a>.</p>
                    </div>
                `,
        image: "/images/mp-stemwall-manufacturing.webp",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <h2 class="page_articleTitle">Tools</h2>
                        <ol>
                            <li>Flat working area 12&#39; long, 4&#39; wide;</li>
                            <li>Hand saw for cutting blocks;</li>
                            <li>Quick-Grip® clamps with 12&quot; long 2x4 extensions;</li>
                            <li>Drill with hex driver for 1-1/2&quot; x #8 wood screws;</li>
                            <li>Foam gun;</li>
                        </ol>

                        <h2 class="page_articleTitle">Materials</h2>
                        <ol>
                            <li>Low expansion EPS foam glue;</li>
                            <li>1-1/2&quot; x #8 coarse wood screws, 1&quot; fender washers for attaching Fastfoot<sup>®</sup>;</li>
                            <li>Fastfoot<sup>®</sup> sewn corners, T-junctions and straights;</li>
                            <li>MP Side Supports;</li>
                        </ol>
                    </div>
                `,
        image: "",
      },
      {
        title: "I - Determine Number & Size of Components",
        body: `
                    <div id="imageSlider"></div>
                    <div id="determineComponents" class="article_textWrapper">
                        <p>There are two types of components: </p>
                        <ul>
                            <li>Straight</li>
                            <li>Corner</li>
                        </ul>
                        <p>Each ICF manufacturer has different block dimensions, so their component sizes vary. Use 
                        information from the foundation plan to determine the number of corner and straight components. 
                        Trim the component when its length does not match the foundation dimension.</p>
                        <p>Fab-Form has developed a 3D model for most ICF blocks which  creates a detailed drawing showing 
                        standard and trimmed components. Should you wish a drawing for your foundation, 
                        <a rel="Contact Us" title="Contact Us" href="/en/contact-us">contact Fab-Form</a>.</p>
                        <p>On the foundation to the right, corner components are shown in pink, straight components in blue, 
                        and trimmed components (to match foundation 
                        dimensions) in yellow.</p>
                    </div>
                `,
        image: "",
      },
      {
        title: "II - Glue Blocks into Components",
        video: {
          video: "https://www.youtube.com/embed/VtmGyS88DOM",
          title: "Glue Blocks into Components",
        },
        body: `
                    <div id="glueComponents">
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBodyWrapper">		                		                
                                <h3>1. Straight Component</h3>
                                <p>Both layers are three blocks long, with the second layer offset two web distances 
                                (12&quot; or 16&quot;) to produce a 'supporting' and a 'supported end'. Run two small 
                                beads of foam glue along horizontal and vertical joints, and clamp as required. 
                                Avoid a single large bead of foam as this will open the joint between the blocks.</p>
                            </div>
                            <img src="/images/mp-component-standard.webp" class="page_articleImg" width="600" height="400" alt="Standard Component" />
                        </div>
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBodyWrapper">
                                <h3>2. Corner Component</h3>
                                <p>The first layer consists of one right hand corner and two standard blocks (to match the sewn 
                                Fastfoot<sup>®</sup> corner). The second layer consists of a left hand corner block and two standard blocks 
                                producing a two web offset at each end&nbsp; (12&quot; or 16&quot;).</p>
                            </div>
                            <img src="/images/mp-component-corner-right.webp" alt="Corner Component" width="400" height="300" />
                        </div>
                    </div>
                `,
        image: "",
      },
      {
        title: "III - Attach Side Supports",
        video: {
          video: "https://www.youtube.com/embed/19ltiOZOwpU",
          title: "Attach Side Supports",
        },
        body: `
                    <div id="attachSideSupports">
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBodyWrapper">
                                <p>Foam glue the plastic foot pad to the adjusting rod to prevent it slipping off inside Fastfoot<sup>®</sup>.</p>
                                <p>Use two 1-1/2” #8 screws through the holes marked &quot;B&quot; (for Block attachment). Use the 
                                two horizontal marks on the metal bracket to align with the bottom of the ICF block. The hole marked 
                                &#39;F&#39; is used to attach Fastfoot<sup>®</sup> to the web.</p>
                            </div>
                        </div>
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBodyWrapper">
                                <h3>1. Straight Component</h3>
                                <p>Attach a pair of supports at the &#39;supporting&#39; end extended to the footing height. Attach 
                                a second pair at the middle unextended. For custom straight components: if lower level distance is 
                                greater than 5&#39;, attach one pair of  supports; if greater than 10&#39;, attach two pairs.</p>
                            </div>
                            <img src="/images/mp-straight-component-with-supports.webp" width="400" height="310" alt="Straight Component with Supports" />
                        </div>
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBodyWrapper">
                                <h3>2. Corner Component</h3>
                                <p>Attach one pair of supports under the &#39;supporting&#39; end, one pair as close to the corner of the component 
                                and one pair 6&#39; from the supported end.
                            </div>
                            <img src="/images/mp-component-corner-with-supports.webp" width="400" height="296" alt="Corner component with Side Supports" /></p>
                        </div>
                    </div>
                `,
        image: "",
      },
      {
        title: `IV - Attach Fastfoot<sup>®</sup>`,
        video: {
          video: "https://www.youtube.com/embed/pTmRPw3SzDM",
          title: "Attach Fastfoot",
        },
        body: `
                    <div id="attachFastfoot">
                        <div class="page_articleWrapper--inner">
                            <div class="page_articleBody">
                                <p>Fastfoot<sup>®</sup> is attached to the base of the ICF block with 1-1/2&quot; x #8 screws and 1&quot; 
                                fender washers through each web, either 6&quot; or 8&quot; on center.&nbsp; The fabric is folded 
                                outwards and the double thickness attached. Use the calculator below to determine the width of 
                                Fastfoot<sup>®</sup> and the distance from the edge for the fold. If the excavation is out of level, be sure 
                                to choose a footing height that covers the deepest section. Adjust the fold line location to 
                                accomodate the footing depth at that location.</p>
                            </div>
                        </div>
                            <h3>Corner Components</h3>
                            <p>Fastfoot<sup>®</sup> sewn corners are available in three sizes: 50&quot;, 62&quot; and 74&quot;. 
                            Screw attach to every web on the inside and outside. The sewn corner is&nbsp;two webs 
                            longer than the component at the supporting end to provide an overlap with the adjacent component.</p>
                            <h3>Straight Components</h3>
                            <p>Cut Fastfoot<sup>®</sup>&nbsp; a two web distance (either 12&quot; or 16&quot;) longer than the length of 
                            the component. At the &#39;supported&#39; end, attach Fastfoot<sup>®</sup> flush with the vertical edge. At the 
                            &#39;supporting&#39; end, extend the fabric a two web distance past end to allow an overlap with 
                            the adjacent component.</p>
                            <div class="page_fastfootCalc_wrapper">
                                <div class="calc_icon"></div>
                                <div>
                                    <form id="fastfootCalc">
                                    <h3>Fastfoot<sup>®</sup> Calculator</h3>
                                <fieldset class="page_articleFieldset">
                                    <legend>Choose ICF Block</legend>
                                    <ol>
                                        <li class="form_flex_list">
                                            <label for="wallThickness">Wall Thickness:</label>
                                            <select id="wallThickness">
                                               <option>Choose</option>
                                               <option value="4">4"</option>
                                               <option value="6">6"</option>
                                               <option value="8">8"</option>
                                               <option value="10">10"</option>
                                               <option value="12">12"</option>
                                            </select>
                                        </li>
                                        <li class="form_flex_list">
                                            <label for="block">Manufacturer:</label>
                                            <select id="block">
                                               <option>Choose</option>
                                               <option value="2.5">Amvic</option>
                                               <option value="2.5">Arxx</option>
                                               <option value="2.5">BuildBlock</option>
                                               <option value="2.5">Fox Block</option>
                                               <option value="2.625">Greenblock</option>
                                               <option value="2.5">IntegraSpec</option>
                                               <option value="2.75">Logix</option>
                                               <option value="2.5">Nudura</option>
                                               <option value="2.5">Polysteel</option>
                                               <option value="4.25">QL Plus</option>
                                               <option value="2.25">QL Std.</option>
                                               <option value="2.5">Reward</option>
                                               <option value="2.625">Superform</option>
                                            </select>
                                        </li>
                                    </ol>
                                </fieldset>
            
                                <fieldset class="page_articleFieldset">
                                        <legend>Choose Footing Size</legend>
                                        <ol>
                                            <li class="form_flex_list">
                                                <label for="footingWidth">Width:</label>
                                                <input type="text" id="footingWidth" size="2"/>
                                            </li>
                                            <li class="form_flex_list">
                                                <label for="footingHeight">Height:</label>
                                                <input type="text" id="footingHeight" size="2"/>
                                            </li>
                                        </ol>
                                </fieldset>
            
                                <fieldset class="page_articleFieldset">
                                        <input id="fastfoot_button" type="button" value="Calculate Fastfoot" class="button" />
                                        <input type="reset" value="Reset" id="reset" class="button" />
                                </fieldset>
            
                                <fieldset class="page_articleFieldset">
                                    <legend>Fastfoot<sup>®</sup></legend>
                                    <ol>
                                        <li class="form_flex_list">
                                            <label for="FastfootWidth">Size:</label>
                                            <input type="text" id="fastfootWidth" size="4" readonly="readonly" disabled/>
                                        </li>
                                        <li class="form_flex_list">
                                            <label for="foldDistance">Fold Distance:</label>
                                            <input type="text" id="foldDistance" size="4" readonly="readonly" disabled/>
                                        </li>
                                    </ol>
                                </fieldset>
                            </form>
                                </div>
                            </div>
                    </div>
                `,
        image: "",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <p><a href="/${lang}/${urls.monopour.mpss.installation}">Site installation</a>.</p>
                    </div>
                `,
        image: "",
      },
    ],
  },
  {
    id: "fastfootMpDoorBuck",
    menuItem: {
      en: {
        url: urls.monopour.mpss.doorBuck,
        title: "Fastfoot Mp Door Buck",
        metaTitle: "Fastfoot Mp Door Buck - Design and Installation",
        metaDescription: "Learn about the design and installation of the Fastfoot MP Door Buck, including its rough opening, installation process, and how to attach Fastfoot® to the door buck using wood screws and washers.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    videos: [
      {
        video: "https://www.youtube.com/embed/ymjX5z2d1D4",
        title: "Fastfoot Mp Door Buck",
      },
    ],
    articles: [
      {
        title: "Door Buck Design",
        body: `
                    <div class="page_article">
                        <p>Where door bucks are located directly above the footing, the base of the door buck forms the 
                        footing, similar to the ICF foundation component.</p>
                        <p>This door buck has a rough opening size of 9&#39; - 0&quot; (two 3&#39; - 0&quot; doors 
                        plus side lights). The distance between the top of the slab and the bottom of the ICF component 
                        is 5&quot;, so the 2x6 bottom buck members were notched 1/2&quot;.</p>
                    </div>
                `,
        image: "/images/door-buck-drawing.webp",
      },
      {
        title: "Door Buck Installation",
        body: `
                    <div class="page_article">
                        <p>The door buck is installed in exactly the same manner as the ICF component. Pairs of side 
                        supports are attached to each end of the bottom of the buck, and leveled up adjacent to the ICF 
                        components.</p> <p>Run horizontal 2x4s across the face of the opening to lock the buck to the 
                        ICF wall in the correct. These 2x4s also support concrete pressures.</p>
                    </div>
                `,
        image: "/images/door-buck-1.webp",
      },
      {
        title: "Attach Fastfoot<sup>®</sup>",
        body: `
                    <div class="page_article">
                        <p>Attach Fastfoot<sup>®</sup> to the bottom of the door buck using 1-1/2&quot; #8 wood screws and washers 
                        6&quot; on center.</p>
                        <p>To support fabric tensions on the bottom of wider bucks, drill 
                        through the two bottom buck members and support with coil rod and nuts.</p>
                        <p><a href="/${lang}/${urls.monopour.mpss.specifications}#coilRod">Fab-Form now stocks coil rod</a> 
                        for information.</p>
                    </div>
                `,
        image: "/images/door-buck.webp",
      },
    ],
  },
  {
    id: "newSewnCorner",
    menuItem: {
      en: {
        url: urls.fastFoot.residential.sewnCorner,
        title: "NEW Fastfoot<sup>®</sup> SEWN CORNERS",
        metaTitle: "NEW Fastfoot® SEWN CORNERS - Faster, Greener, Economic, and Stronger",
        metaDescription: "Discover the benefits of the NEW Fastfoot® Sewn Corners, offering faster installation, reduced waste, cost efficiency, and enhanced strength. Perfect for your footing form needs.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    videos: [
      {
        video: "https://www.youtube.com/embed/6RKmxn8Ir_4",
        title: "Fastfoot<sup>®</sup> Footing Form, Sewn 90 Degree Corners",
        splashScreen: "/images/fab-form-footing-form-youtube.webp",
      },
    ],
    articles: [
      {
        title: "Faster",
        body: `
                    <div class="page_article">
                        <p>Sewn corners are installed in seconds. No need to fold and cut - just drop in place and staple.</p>
                        <p><a href=""../${urls.fastFoot.residential.installation}">Installation guide.</a></p>
                    </div>
                `,
        image: "/images/full-corner.webp",
      },
      {
        title: "Greener",
        body: `
                    <div class="page_article">
                        <p>Corners are cut and sewn by reversing the pattern so that there is NO production waste.</p>
                    </div>
                `,
        image: "/images/greener.webp",
      },
      {
        title: "Economic",
        body: `
                    <div class="page_article">
                        <p>The lineal cost of the corner is the SAME as the lineal cost of the Fastfoot<sup>®</sup> roll. </p>
                        <p>The cutting and sewing cost is offset by the fabric saving. Everyone wins: you, us and the environment.</p>
                    </div>
                `,
        image: "/images/seamon-corner.webp",
      },
      {
        title: "Stronger",
        body: `
                    <div class="page_article">
                        <p>Corner seams are double stitched, so no danger of blowout.</p>
                    </div>
                `,
        image: "/images/seam-close-up.webp",
      },
    ],
  },
  {
    id: "3newProducts",
    menuItem: {
      en: {
        url: "3-new-products",
        title: "3 New Products",
        metaTitle: "Fab-Form Announces the Release of Three New Products - ZAT Bracket, Prefab Foundation Components, Fast-Tube CLEAR",
        metaDescription: "Fab-Form unveils three groundbreaking products: the ZAT bracket for foundation catwalks, world-first prefab foundation components, and the upgraded Fast-Tube CLEAR with enhanced visibility during concrete pouring.",
      },
    },
    category: "none",
    images: [],
    body: ``,
    articles: [
      {
        title: "Fab-Form Announces the Release of Three New Products",
        body: `
                    <div class="page_article">
                        <p><em>"We're excited to announce the release of three new products for the fall of 2017",</em> 
                        said Rick Fearn, President of Fab-Form. <em>"The ZAT bracket completes our Zont Bracing System, 
                        allowing the contractor to quickly install his catwalk."</em></p>
                        <p><em>"The prefab foundation components are a world first. We're setting up a separate division 
                        to manufacture the components, including the footing formwork. We'll be licensing this patented 
                        technology around the world."</em></p>
                        <p><em>"We have dramatically improved the Fast-Tube using clear fabric, so you can see the concrete 
                        being poured and a stronger fabric for improved performance. We now offer diameters from 8" to 20". </em></p>
                        <p>Click on each image below for product information.</p>
                        <p>For information on Fab-Form, <a href="/${lang}/${urls.investor.about}">the PUBLIC COMPANY</a>.</p>
                    </div>
                `,
        image: "",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <p>The all new ZAT walkway bracket is the ideal solution for installing foundation catwalks.
                        <a href="/${lang}/${urls.zontBracing.components.zat}">ZAT bracket</a>.</p>
                    </div>
                `,
        image: "/images/zat-release.webp",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <p>The world's first: pre-fabricated foundation components that include the footing forms.  
                        <a href="/${lang}/${urls.monopour.mpss.overview}">Click here for more information</a>.</p>
                    </div>
                `,
        image: "/images/prefab-release.webp",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <p>Finally a clear column form that allows you to see the concrete - Fast-Tube CLEAR.                     </div>
                `,
        image: "/images/clear-release.webp",
      },
    ],
  },
  {
    id: "fastTubeClear",
    menuItem: {
      en: {
        url: "fast-tube-clear",
        title: "Fast Tube Clear",
        metaTitle: "Fast-Tube CLEAR - Superior Column Form with Enhanced Visibility and Strength",
        metaDescription: "Discover Fast-Tube CLEAR, the superior column form offering 26% greater strength, clear visibility during pours, and easy-to-follow installation with diameters ranging from 8\" to 20\".",
      },
    },
    category: "none",
    images: [],
    body: ``,
    articles: [
      {
        title: "Fast-Tube CLEAR",
        body: `
                    <div class="page_article">
                        <p>CLEAR is an outstanding column form for forming utility concrete columns.</p>
                        <p>CLEAR offers the following advantages:</p>
                        <ul>
                            <li>CLEAR polyethylene form allows you to see concrete and reinforcing before and during the concrete pour;</li>
                            <li>CLEAR fabric is 26% stronger than the previous silver/black fabric, ensuring a solid pour;</li>
                            <li>CLEAR diameters now available: 8" through 20";</li>
                            <li>CLEAR installation guide is now printed directly on the fabric for easy installation.</li>
                        </ul>
                    </div>
                `,
        image: "/images/clear-release.webp",
      },
    ],
  },
  {
    id: "tsxVenture50",
    menuItem: {
      en: {
        url: "investor/tsx-venture-50",
        title:
          "Fab-Form Ranks Among Top 50 Performing Companies on the 2023 TSX Venture 50®",
        metaTitle: "Fab-Form Ranks Among Top 50 Performing Companies on the 2023 TSX Venture 50®",
        metaDescription: "Fab-Form Industries Ltd has been named among the top 50 performers on the 2023 TSX Venture 50. Learn more about this prestigious recognition and watch the video highlighting Fab-Form's achievements.",
      },
    },
    category: "none",
    images: [],
    videos: [
      {
        video: "https://www.youtube.com/embed/RCBQ-ZWO44Y",
        title: "Fab Form on TSX Venture 50",
      },
    ],
    body: ``,
    articles: [
      {
        title: "",
        body: `
                    <div class="page_article">
                        <div class="page_tsxContent">
                            <p>Fab-Form Industries Ltd is pleased to announce that it has been named as one of the top performers on the TSX
                            Venture Exchange. The 2023 TSX Venture 50 celebrates the strongest performances on the TSX Venture Exchange
                            (the “TSXV” or “the Exchange”) over the last year. More details on the 2023 TSX Venture 50 and a video highlighting
                            Fab-Form can be found at <a rel="noreferrer" href="https://v50.stocktrak.com/">tsx.com/venture50</a></p>
                            <img class="tsx_banner" alt="TSX Venture 50" src="/images/venture-50-2022.webp"/></a>
                        </div>
                    </div>
                `,
        image: "",
      },
      {
        title: "",
        video: {
          video: "https://www.youtube.com/embed/pP-PNoi4OFs",
          title: "TSX Venture 50",
        },
        body: `
                    <div class="page_article">
                        <p>The Venture 50 are the top ten companies listed on TSX Venture Exchange in each of five major industry
                        sectors – mining, energy & energy services, clean technology & life sciences, diversified industries, and
                        technology – based on a ranking formula with equal weighting given to market cap growth, trading volume
                        amount and share price appreciation. All data was as of December 31, 2022. *</p>
                        <p><em>*The Venture 50 ranking is provided by TSX Venture 
                        Exchange Inc. (“TSXV”) for information purposes only. Neither
                        TMX Group Limited nor any of its affiliated companies guarantees the completeness of this information and are
                        not responsible for any errors or omissions in or any use of, or reliance on, this information. The Venture
                        50 program is not an invitation to purchase securities. listed on TSX Venture Exchange. TSXV and its affiliates
                        do not endorse or recommend any of the referenced securities or issuers, and this information should not be
                        construed as providing any trading, legal, accounting, tax, investment, business, financial or other advice
                        and should not be relied on for such purposes.</em></p>
                    </div>
                `,
        image: "",
      },
    ],
  },
  {
    id: "terms",
    menuItem: {
      en: {
        url: "terms",
        title: "Fab-Form Terms of Sale",
        metaTitle: "Fab-Form Terms of Sale",
        metaDescription: "Read the official Terms of Sale for Fab-Form products, including payment terms, delivery policies, warranties, and more. Understand the conditions that govern all sales made by Fab-Form.",
      },
    },
    category: "none",
    images: [],
    videos: [],
    body: `
            <ul>
                <li>COMPLETE TERMS: All sales by Fab-Form are governed by these terms and conditions of 
                sale (&quot;Terms&quot;), together with other sales terms, if any, agreed to by the Buyer 
                and Fab-Form in writing (&quot;Sales Terms&quot;), such as those on written Sales Orders, 
                Invoices and Quotations. In the event of an inconsistency, the Terms shall prevail. These Terms, together 
                with the Sales Terms, if any, are referred to herein as the &quot;Agreement&quot;. These 
                Terms constitute the entire agreement between the Buyer and Fab-Form regarding the sale of products 
                (&quot;Products&quot;) by Fab-Form to the Buyer and sets out the final and complete 
                expression of all terms and conditions of this Agreement. Any representations, promises, warranties, or 
                statements that are not contained in this Agreement are void. If this Agreement is or is deemed to be an 
                acceptance of a prior offer by Fab-Form or the Buyer, the acceptance is conditional on the Buyer's 
                acceptance of these terms and conditions. Fab-Form hereby gives notice that it expressly rejects any 
                terms or conditions contained in any document that has been, or may in the future be, supplied to it by 
                the Buyer which are inconsistent with, or attempt to vary, any of this Agreement, whether such terms or 
                conditions are set forth in the Buyer's bid, proposal, order acknowledgement, invoice, or otherwise 
                disclosed to Fab-Form. Fab-Form's sale or delivery of any Products to the Buyer will not be construed as 
                an acceptance of any terms or conditions contained in any document provided by the Buyer. Any action by 
                the Buyer in furtherance of a sale or purchase of Product shall constitute acceptance of this Agreement. 
                These terms and conditions can be modified, waived, or amended only in writing signed by an authorized 
                representative of both the Buyer and Fab-Form.</li>
                     
                <li>ORDERS / ORDER CHANGES. Orders for Products will be submitted by the Buyer to 
                Fab-Form in writing and in English using Fab-Form's then current product specifications.</li>
                     
                <li>TERMS OF PAYMENT. The price for Product is the price in effect on the date of shipment, 
                unless otherwise agreed to by the Buyer and Fab-Form in writing. Fab-Form may adjust the price of any 
                Product upon at least thirty (30) days prior notice unless otherwise agreed to by the Buyer and Fab-Form 
                in writing. Payment is due according to the terms set forth on the invoice issued by Fab-Form. If the 
                Buyer fails to pay any sum owed hereunder when due, interest shall accrue and be payable by the Buyer to 
                Fab-Form on such sum at the rate of 1.5% per month or the highest rate allowed by law, whichever is lower. 
                If Fab-Form, in its sole discretion, finds it necessary to employ an agent or attorney to collect any 
                past due sum owed hereunder, it may collect, in addition to any other sum owed hereunder, reasonable 
                agent's or attorney's costs (including fees, disbursements and taxes).</li>
                     
                <li>FINANCIAL RESPONSIBILITY. Any credit terms offered by Fab-Form are available only 
                for so long as the Buyer complies with all of its obligations under this Agreement, including, without 
                limitation, the provisions requiring timely payment of invoices within the required time. If credit terms 
                are no longer available, the Buyer shall pay cash in advance for all purchases. If Fab-Form has any doubt 
                at any time as to the Buyer's financial situation, Fab-Form, at its option, may either (a) decline to make 
                further shipments except upon receipt of cash in advance or upon giving of other security satisfactory to 
                Fab-Form, or (b) terminate this sale. Nothing in this paragraph is intended to affect the obligation of 
                the Buyer to accept and pay for the Products.</li>
                     
                <li>NO DEDUCTION. The Buyer shall not be entitled to deduct from the price invoiced to 
                it by Fab-Form the amount of any claim asserted by the Buyer against Fab-Form, unless such claim has been 
                allowed in writing by Fab-Form. The provisions of the preceding sentence are of the essence of this sale.</li>
                     
                <li>TAXES. All sales, excise, or other forms of taxes and duties levied against this 
                transaction shall be paid by the Buyer over and above all other sums the Buyer may be or may become 
                obligated to pay hereunder. If the Buyer is located in the USA and if the transaction cost is greater 
                than $2,000, the Buyer must supply a Federal Tax ID number to Fab-Form for the US Government.</li>
                     
                <li>TITLE AND RISK. Fab-Form  warrants it has and will convey good and marketable title 
                to the Products. Unless otherwise provided in this Agreement, risk of loss of Product shall transfer to 
                the Buyer at Fab-Form's or the original manufacturer's plant at which the Products are manufactured when 
                the Product has been loaded onto the carrier taking delivery of the Product, regardless of whether the 
                Buyer or Fab-Form is arranging for the transportation of the Products. In addition, unless otherwise 
                provided in this Agreement, title to Product shall transfer to the Buyer simultaneously with risk of loss.</li>
                     
                <li>DELIVERY. Unless otherwise agreed in writing by the parties, Fab-Form will arrange 
                for transportation of the Products from Fab-Form's or the  original manufacturer's plant at which the 
                Products are manufactured to the destination required by the Buyer, then: (a) the delivery dates are 
                approximate and subject to carrier availability, (b) Fab-Form reserves the right to route all shipments 
                and may assist the Buyer in processing claims against carriers, without incurring liability therefore, 
                (c) the Buyer agrees to be responsible for timely off-loading of Products at their destination (typically 
                two hours for a truckload), and any costs payable for any delay in the timely offloading of Products by 
                the Buyer shall be for the Buyer's account, (d) any increase in delivery costs resulting from the Buyer's 
                inaccurate or revised delivery address or instructions to Fab-Form or to the carrier, and any extra costs 
                of utilizing substitute methods of delivery or off-loading, including when the intended type of carrier 
                or loading or unloading facilities become unavailable, shall be for the Buyer's account, (e) any claims 
                for loss or damage after risk of loss has passed shall be filed by the Buyer with the carrier, (f) Fab-Form 
                shall not be liable for loss or damage from delay in delivery or failure to manufacture, (g) if delivery 
                is delayed at the request of, or due to acts or omissions by the Buyer, Fab-Form shall have the right to 
                store the Products at a place of its own choice for the Buyer's account and risk and to invoice the Buyer in 
                accordance with the original invoicing and payment terms and for such storage charges incurred as a result 
                of the delay.</li>
                     
                <li>INSPECTION AND ACCEPTANCE: The Buyer shall, upon delivery of Products to the destination 
                at which they are unloaded from the carrier that is transporting the Products from Fab-Form's or the 
                original manufacturer's plant are manufactured, immediately count and inspect and either accept or reject 
                such Products within a reasonable period not to exceed fourteen (14) calendar days of delivery (the 
                &quot;Acceptance Period&quot;). In the event that Products do not comply with the 
                requirements under this Agreement, the Buyer shall promptly notify Fab-Form and provide a specific 
                written explanation of the basis for rejection. The Buyer shall be deemed to have accepted any Product 
                delivered hereunder and to have waived any right to reject in the event that Fab-Form does not receive 
                such notice of rejection within the Acceptance Period. Fab-Form shall be afforded a reasonable opportunity 
                to repair or replace non-conforming Product at Fab-Form's option, provided that, if Fab-Form reasonably 
                determines that the Product complied with the requirements under this Agreement when the Product was 
                loaded onto the carrier taking delivery of the Product, then all expenses related to the improper rejection 
                are the responsibility of the Buyer.</li>
                     
                <li>RETURN OF PRODUCT: Stock Products may be returned within 90 days of purchase. Special 
                Order Products cannot be returned. A RMA (Return Merchandise Number) will be issued by Fab-Form authorizing 
                said return. Fab-Form is not responsible for freight costs associated with Product returns. Restocking 
                fee is 8% which may be adjusted upon inspection of Product returned, based on damage to Product 
                (including packaging). Returns must be received within 14 days of Fab-Form's date of RMA issuance.</li>
                     
                <li>PRODUCT PROTECTION. To avoid Product damage and/or mold growth, the Buyer shall 
                protect all Products from physical damage, moisture and ultraviolet light exposure according to industry 
                customs during transit, storage, and use, including without limitation, transit to, storage at, and use 
                on a jobsite.</li>
                     
                <li>RESALE OF PRODUCTS. If the Buyer is reselling any Product, the Buyer agrees to 
                furnish its purchasers copies of these Terms and incorporate these Terms in the Buyer's sales order and 
                invoice forms, and Fab-Form agrees to make copies available upon request. In all events and regardless 
                of whether the Buyer complies with this provision, the rights of such purchasers shall be determined 
                under the provisions of this Agreement.</li>
                     
                <li>DELAYS/FORCE MAJEURE. In the event Fab-Form is unable to ship the ordered Products 
                because of fire, flood, windstorm, or other act of God, labor or civil disturbance, shortage of raw 
                materials, failure of timely delivery by Fab-Form's suppliers, energy or transportation shortages, or any 
                other cause whether or not similar to the causes listed above, beyond Fab-Form's reasonable control, 
                Fab-Form reserves the right to cancel the affected order without any liability to the Buyer whatsoever. 
                In no event shall Fab-Form be obligated to purchase material from others to enable Fab-Form to deliver 
                Products to the Buyer hereunder.</li>
                     
                <li>
                <p>WAIVERS AND RELEASES. Fab-Form assumes no responsibility 
                regarding the Buyer's use of its Products or any other third party Products resold by Fab-Form. It is the 
                responsibility of the Buyer and any others who use or install the Products to comply with all applicable 
                regulations and building code requirements concerning the use of the Products. It is further the responsibility 
                of the Buyer and any others who use or install the Products to research and understand safe methods 
                of use and handling of the Products.</p>
                <p>INSTALLATION WAIVER AND RELEASE. The Buyer acknowledges and assumes all responsibility for the 
                safe installation of Products, and hereby RELEASES, REMISES AND FOREVER DISCHARGES Fab-Form, Fab-Form's 
                affiliates and each of their respective directors, officers, employees and agents (collectively, the 
                &quot;Released Fab-Form Parties&quot;) FROM ANY AND ALL LOSSES, CLAIMS, SUITS, DEMANDS, 
                ACTIONS, CAUSES OF ACTION, LIABILITIES, PENALTIES, COSTS, EXPENSES (INCLUDING LEGAL FEES AND DISBURSEMENTS), 
                JUDGMENTS AND DAMAGES OF ANY NATURE OR KIND WHATSOEVER, whether under contract, tort or any other theory of 
                law or equity (collectively, &quot;Claims&quot;), that arise or accrue from, as a result of, 
                in relation to, or in connection with, the installation of Products by any person from and after being 
                purchased by the Buyer from Fab-Form, including, but without limitation, loss or damage to any person's 
                property, or personal injury to, or death of, any person, and whether or not caused or contributed to by the 
                negligence, imprudence, lack of skill, error of judgment or any other act or omission of any of the 
                Released Fab-Form Parties. In addition, and without limiting the generality of the foregoing, the Buyer 
                will inform staff, customers, and agents of the following guidelines on the proper use of Products in 
                accordance with, but not limited to, ACI (American Concrete Institute) 347 &quot;Guide to Formwork for 
                Concrete&quot;, NBCC and/or CAN/CSA A23, and/or any other current applicable codes and regulations. Any 
                variance from those standards must be provided and certified in advance by a qualified engineer, 
                licensed for the jobsite location and specifications.&quot;</p>
                <p>ENGINEERING WAIVER AND RELEASE. The Buyer acknowledges and assumes all responsibility 
                for job-specific engineering for any and all projects in which the Products are used after being purchased 
                by the Buyer from Fab-Form, including, but without limiting the generality of the foregoing, any and all 
                engineering work done by any and all licensed structural engineers and any and all engineering relating 
                to job-specific concrete reinforcing and design specifications, whether done directly by or indirectly 
                for the Buyer, and hereby RELEASES, REMISES AND FOREVER DISCHARGES the Released Fab-Form Parties FROM ANY 
                AND ALL CLAIMS (as the term &quot;Claims&quot; is defined above) that arise or accrue from, as a result 
                of, in relation to, or in connection with, any and all job-specific engineering for any and all projects 
                in which the Products are used by any person from and after being purchased by the Buyer from Fab-Form, 
                including, but without limitation, loss or damage to any person's property, or personal injury to, or 
                death of, any person, and whether or not caused or contributed by the negligence, imprudence, lack of 
                skill, error of judgment or any other act or omission of any of the Released Fab-Form Parties. In addition, 
                and without limiting the generality of the foregoing, the Buyer will inform staff, customers, and agents 
                of the following guidelines on the proper use of the Products: The installer is responsible for placement 
                of all reinforcing steel and concrete in accordance with, but not limited to, ACI (American Concrete 
                Institute) 318 <em>&quot;Building Code Requirements for Structural Concrete&quot;</em>, NBCC and/or CAN/CSA 
                A23, and/or any other current applicable codes and regulations. Any variance from those standards must be 
                provided and certified in advance by a structural engineer, licensed for the jobsite location and specifications.</p>
                <p>COMPLIANCE WITH LAWS. The Buyer assumes full liability and responsibility for compliance 
                with all applicable laws, statutes, ordinances and regulations of any governmental authority including, 
                without limitation, any relating to occupational health and safety, any locally applicable building codes, 
                the <em>Foreign Corrupt Practices Act</em>, the anti-money laundering provisions of the <em>USA Patriot 
                Act</em> and <em>Bank Secrecy Act</em>, and Canadian and United States export control laws. The Buyer 
                shall not resell or ship to persons on the denied parties list or persons located within embargoed 
                countries (in both cases as defined under the applicable export control laws). Fab-Form assumes no liability 
                for the Buyer's failure to comply with the Buyer's obligations arising under European Union REACH (Registration, 
                Evaluation, Authorization, and Restriction of Chemicals) Regulations. The Buyer shall defend, indemnify 
                and hold harmless each of the Released Fab-Form Parties from and against all Claims arising out of or 
                related to (i) the Buyer's (or others') processing, transportation, delivery, unloading, discharge, storage, 
                handling, sale or use of any Product (or any product containing Product) or (ii) the Buyer's violation of 
                or failure to comply with any applicable laws or regulations.</p></li>
                     
                <li>LIMITED WARRANTY
                <p>Fab-Form Products Limited Warranty: Fab-Form warrants that its 
                Products comply with their published specifications and are free from manufacturing defects 
                (&quot;Defects&quot;). If the customer believes that the Products have 
                Defects, the customer will return samples of the defective Products to Fab-Form and upon Fab-Form being 
                satisfied that the Products have Defects, Fab-Form will replace the defective Products or refund the 
                purchase price, at Fab-Form's option.</p>
                <p>Third-Party Products' Limited Warranty: Products supplied by and manufactured for 
                third parties and resold by Fab-Form are warranted to comply with the warranty and specifications of the 
                original manufacturer or producer of the Products. Should any Product sold hereunder be found not to meet 
                the foregoing warranty, Fab-Form will take such action as is specified in the warranty of the original 
                manufacturer or producer, or, at Fab-Form's election, make a fair allowance therefore. Written notice of 
                any claim under this warranty must be given to Fab-Form within the time specified in the warranty of the 
                original manufacturer or producer not to exceed one (1) year after delivery of Products, and the Buyer 
                must afford Fab-Form a reasonable opportunity to inspect the Products in unaltered condition and evaluate 
                the claims in accordance with procedures specified in the original manufacturer's or producer's warranty.</p>
                <p>This warranty shall be exclusive and in lieu of any other representation or warranty, express or implied, 
                including those arising by statute, operation of law, custom of trade or otherwise. Without limiting the 
                generality of the foregoing, Fab-Form assumes no responsibility and makes no other representation or 
                warranty, express or implied, whether arising by statute, operation of law, custom of trade or otherwise, 
                as to the merchantability or fitness for a particular purpose of its Products or the performance or results 
                of an installation using its Products. The Buyer hereby irrevocably waives any and all rights with respect 
                to any implied terms or warranties under the provisions of the <em>Sale of Goods Act</em> or under any law 
                or legislation of similar effect whether now or hereafter in effect.</p></li>
                     
                <li>INDEMNITY: The Buyer hereby AGREES TO INDEMNIFY AND HOLD HARMLESS each of the Released 
                Fab-Form Parties FROM AND AGAINST ANY AND ALL CLAIMS (as the term &quot;Claims&quot; is defined above) 
                that any of the Released Fab-Form Parties may sustain, suffer, incur or be required to pay that arises 
                or accrues from, as a result of, in relation to, or in connection with, any matter that is the subject 
                of any of the releases provided above by the Buyer or as a result of the Buyer's or third party's misuse 
                or misapplication of any Products.</li>
                     
                <li>LIMITATION OF LIABILITY: The Buyer's sole remedy for a breach of this Agreement by 
                Fab-Form shall be limited to replacement by Fab-Form of the Products involved or, at Fab-Form's option, 
                return by Fab-Form to the Buyer of the purchase price of the Products involved in such breach. Fab-Form's 
                liability on any Claim of any kind arising out of, connected with, or resulting from this Agreement or 
                the performance or breach of this Agreement, or from the design, manufacture, sales, delivery, resale, 
                installation, repair, operation or use of any Products covered by or furnished under this Agreement shall 
                in no case exceed the purchase price of the Products which gives rise to the Claim. IN NO EVENT, WHETHER 
                AS A RESULT OF BREACH OF CONTRACT OR WARRANTY OR NEGLIGENCE OR OTHER TORT OR OTHERWISE, SHALL FAB-FORM 
                BE LIABLE TO THE BUYER OR ANY OTHER PERSON FOR SPECIAL, INCIDENTAL, CONSEQUENTIAL OR INDIRECT DAMAGES, 
                INCLUDING, BUT NOT LIMITED TO, LOSS OF PROFITS OR REVENUE, LOSS OF USE OF PRODUCTS OR ANY OTHER EQUIPMENT, 
                COST OF CAPITAL, COST OF SUBSTITUTE EQUIPMENT, FACILITIES OR SERVICES, DOWNTIME COSTS, OR CLAIMS OF 
                CUSTOMERS OF THE BUYER FOR SUCH DAMAGES EVEN IF FAB-FORM HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH 
                DAMAGE OR LOSS BY THE BUYER OR ANY THIRD PARTY. ANY LEGAL ACTION AGAINST FAB-FORM FOR BREACH OF THESE 
                TERMS, INCLUDING ANY WARRANTIES, MUST BE INSTITUTED WITHIN ONE YEAR AFTER DELIVERY OF THE PRODUCTS.</li>
                     
                <li>BREACH, TERMINATION: If the Buyer breaches any term of this Agreement or any other 
                contractual obligation, (a) Fab-Form may choose to defer any or all further shipments or other performance 
                under this Agreement and performance of any other contractual obligation in favor of the Buyer until the 
                Buyer cures its breach, or (b) Fab-Form may immediately terminate this Agreement, if the Buyer fails to 
                cure such breach within ten (10) days after receipt of written notice from Fab-Form describing such breach. 
                In the event of a termination, all outstanding payment obligations or other indebtedness of the Buyer to 
                Fab-Form shall be due and payable no later than fifteen (15) days after delivery of notice of termination. 
                Acceptance by Fab-Form of less than the full amount due shall not be a waiver of any of Fab-Form's rights 
                under this Agreement or applicable law. In any event, the Buyer shall remain liable for all loss and damage 
                sustained by Fab-Form because of the Buyer's breach. Notwithstanding any provision in this Agreement, 
                Fab-Form shall have no obligation to pay any rebate, issue any credit or make any other payment of any 
                kind to the Buyer unless the Buyer is fully in compliance with its payment and other obligations under 
                this Agreement and any other contractual obligation in favor of Fab-Form. In addition, in the event that 
                the Buyer fails to make any payment when due, Fab-Form shall have the right to offset any and all 
                outstanding payment obligations or other indebtedness of the Buyer to Fab-Form against any outstanding payment 
                obligations or other indebtedness that Fab-Form or any of its affiliates may owe the Buyer.</li>
                     
                <li>ASSIGNMENT / ENUREMENT: Neither party to this Agreement shall assign this Agreement 
                or any portion thereof without the advance, written consent of the other party, which consent shall not 
                be unreasonably withheld. Notwithstanding the forgoing, either party may assign this Agreement in the event 
                of a merger, consolidation or reorganization or in connection with the sale of all or substantially 
                all of the assets of the business of the party to which this Agreement relates. This Agreement 
                shall enure to the benefit of and shall be binding upon the parties and their respective successors and 
                permitted assigns.</li>
                     
                <li>SEVERABILITY: If any provision of this Agreement is held invalid or unenforceable 
                in accordance with its express terms in any legal proceeding in any jurisdiction, it shall, as only to 
                that jurisdiction, be separate, severable and distinct from each and every other obligation or duty and 
                shall not affect the validity and enforceability of any other part of this Agreement.</li>
                     
                <li>NO WAIVER: Failure or delay of Fab-Form to exercise a right or power under this 
                Agreement shall not operate as a waiver thereof, nor shall any single or partial exercise of a right or 
                power preclude any other future exercise thereof.</li>
                     
                <li>REFERENCES: References to the singular or masculine used in this Agreement will be 
                deemed to include references to the plural, feminine or body corporate as the context may require.</li>
                     
                <li>CONSTRUCTION: The division of this Agreement into articles and the insertion of 
                headings are for convenience of reference only and are not to affect the construction or interpretation 
                of this Agreement.</li>
                     
                <li>NO PARTNERSHIP: The Buyer and Fab-Form are independent contractors and nothing in 
                this Agreement constitutes either party to this Agreement as an agent, partner or joint venturer of or 
                with the other party to this Agreement.</li>
                     
                <li>GOVERNING LAW: Any transaction subject to this Agreement shall be construed and 
                governed in all respects by the laws of the province of British Columbia, Canada (without regard to its 
                conflicts of law rules). The United Nations Convention on Contracts for the International Sale of Goods 
                shall not apply to this Agreement.</li>
                     
                <li>WAIVER OF JURY TRIAL / BINDING ARBITRATION: The Buyer hereby waives all rights to a 
                trial by jury. The Buyer consents that all disputes arising out of or relating to this Agreement shall be 
                settled finally by arbitration under the Rules of the British Columbia International Commercial Arbitration 
                Centre (&quot;BCICAC&quot;). The arbitration will take place before one arbitrator 
                appointed in accordance with the BCICAC Rules. The place of arbitration shall be in the City of Vancouver, 
                British Columbia. Any hearings shall be conducted in Vancouver, British Columbia, and will be conducted 
                in English. Except for travel and lodging expenses, which will be borne by each party separately, any and 
                all costs of arbitration and any and all lawyer's fees will be borne by the Buyer and/or Fab-Form as 
                determined by the arbitrator depending on the arbitration's outcome.</li>
                
                <li>GENERAL: These Terms, as published on Fab-Form's website 
                <a href="/${lang}/terms">Fab-Form Industries Terms</a>  at the time of sale, are the official terms and conditions 
                of sale between Fab-Form and the Buyer and may be amended from time to time without notice at Fab-Form's 
                sole discretion.</li>
            </ul>	
        `,
  },
  {
    id: "careerOpportunities",
    menuItem: {
      en: {
        url: "career-opportunities",
        title: "Career Opportunities",
        metaTitle: "Career Opportunities at Fab-Form",
        metaDescription: "Explore exciting career opportunities at Fab-Form. Join our fast-growing team, contribute to innovative projects, and enjoy great benefits like bonuses, health allowances, and more.",
      },
    },
    category: "none",
    images: ["/images/corner-driver.webp"],
    videos: [],
    body: "",
    articles: [
        {
            body: `
            <div>
                <p>The star of our team is Conner, driving the four wheel drive Nudura corner block. Notice the web 
                suspension and 1x4 steering wheel, all essential for safe mobility on the jobsite. Good job, Conner!</p>
                <p>Fab-Form is a fast growing public company located on Annacis Island, Delta BC. We've been in business 
                since 1986, but only recently has the market caught up with our innovative products that tame the uneven 
                ground to accept manufactured components. We're the only company in the world that focuses exclusively on 
                this interface. <a href="/${lang}/${urls.investor.about}">Learn more</a>.</p>
                <p>Here's what you can expect if you join our team:</p>
                <ul>
                    <li><em>Team spirit</em>: if one department is behind, we all pitch in to help</li>
                    <li><em>Share in our growth</em>: we all get a 10% yearly bonus paid in shares</li>
                    <li><em>Cost of living adjustment</em>: paid in January each year to ensure you're not falling behind to inflation</li>
                    <li><em>Health and wellness allowance</em></li>
                    <li><em>Learning environment</em>: we're here to help upgrade your knowledge and skills</li>
                </ul>
            </div>
        `
        },
      {
        title: "ACCOUNTANT ADMINISTRATIVE ASSISTANT EXTRA-ORDINAIRE",
        body: `
                    <p>This is a very exciting position: you'll be assisting our controller Vish with his diverse duties: 
                    managing the public company, coordinating digital communications between customer service, accounting, 
                    sales, and the warehouse. There's never a dull moment here: we're moving to a new factory with double 
                    the space and on top of all that, Vish is introducing a new CRM/Accounting system. 
                    <a href="/docs/accountant-administrative-assistant-sep-2022.pdf" onclick="window.open(this.href,'_blank');return false;">For more information on this 
                    exciting opportunity, click here</a>.</p>

                `,
      },
    ],
  },
  {
    id: "allNewFastfoot",
    menuItem: {
      en: {
        url: "fastfoot-residential/all-new-fastfoot",
        title: "All New Fastfoot",
        metaTitle: "All New Fastfoot | Enhanced Strength and Protection",
        metaDescription: "Discover the all-new Fastfoot with enhanced strength, tighter weave, better moisture protection, and easy footing width lines. Improve your installation with new distance lines and QR code guides.",
      },
    },
    category: "none",
    images: [],
    videos: [],
    body: ``,
    articles: [
      {
        title: "Stronger",
        body: `
                    <div class="page_article">
                        <p>The high density polyethylene tapes are 38% stronger.</p>
                        <p>Form deeper footings without danger of blowout. And stretching is reduced proportionately, 
                        reducing concrete consumption.</p>
                    </div>
                `,
        image: "/images/fastfoot-ram.webp",
      },
      {
        title: "Tighter Weave",
        body: `
                    <div class="page_article">
                        <p>The weave has been increased from an 8x8 scrim to a 10x10 scrim, improving the staple holding 
                        power by 20%.</p>
                    </div>
                `,
        image: "/images/tighter-weave.webp",
      },
      {
        title: "Better Moisture Protection",
        body: `
                    <div class="page_article">
                        <p>The high density polyethylene scrim is coated on both sides with a low density polyethylene.</p>
                        <p>The coating thickness has been increased by 20% on each side to improve impermeance.</p>
                    </div>
                `,
        image: "/images/better-moisture-protection.webp",
      },
      {
        title: "Footing Width Lines",
        body: `
                    <div class="page_article">
                        <p>Accommodating different footing widths and depths is a breeze with the colored lines which are 
                        marked with the footing width dimension.</p>
                    </div>
                `,
        image: "/images/footing-width-lines.webp",
      },
      {
        title: "Distance Lines",
        body: `
                    <div class="page_article">
                        <p>New distance lines, spaced 12" on center along the length, allow the installer to ensure both 
                        edges are aligned perpendicular to each other. This prevents lateral wrinkles due to misalignment 
                        of the edges.</p>
                    </div>
                `,
        image: "/images/distance-lines.webp",
      },
      {
        title: "QR Codes",
        body: `
                    <div class="page_article">
                        <p>QR codes take the installer immediately to the web-based installation guide. There is a separate 
                        QR code for residential and commercial footings.</p>
                    </div>
                `,
        image: "/images/qr-codes.webp",
      },
    ],
  },
  {
    id: "cmhcMoldReport",
    menuItem: {
      en: {
        url: urls.fastFoot.residential.cmhcMoldReport,
        title: `CMHC Report "Molds in Finished Basements"`,
        metaTitle: "CMHC Report: Molds in Finished Basements | Fab-Form",
        metaDescription: "Read the CMHC report on mold growth in finished basements and its impact on indoor air quality. Learn how rising damp contributes to mold and how Fastfoot® can prevent it.",
      },
    },
    category: "none",
    images: ["/images/rising-damp-main.webp"],
    videos: [],
    body: "",
    articles: [
        {
            body: `
            <div>
                <p>(Canada Mortgage and Housing Corporation, Canada's National Housing 
                  Agency), conducted a survey of 405 houses in the Ottawa region of Ontario, 
                  Canada. The objective of the survey was <em>&quot;to determine whether typical 
                  'finished' basements are contributing to poor indoor air quality as a 
                  result of mold growth in the finishing materials&quot;</em>.
                  About half of the 405 houses <em>&quot;had signs of moisture in the basement&quot;</em>. The 
                  study then selected 22 for further investigation. Molds were found in 18 
                  of the 22 houses, or 82%. Mold samples were taken from 16 of the 18 
                  houses.</p>
                <p> In 100% of those houses, <em>&quot;molds with properties that are harmful 
                  to humans were found.&quot; </em>	</p>
                <p>The study concluded:</p>
                <ol>
                    <li>&quot;Some finished basements do present health hazards to the occupants 
                    due to the presence of toxigenic and dangerous molds in the wall 
                    cavities&quot;</li>
                    <li>&quot;The causes of mold growth in finished basements are directly 
                    related to chronic wetting incidents rather than the wall finishing and 
                    insulating techniques&quot;</li>
                    <li>&quot;The main chronic moisture sources associated with mold growth in finished basements are exterior moisture sources and wetting mechanisms&quot;</li>
                </ol>
                <p><a href="ftp://ftp.cmhc-schl.gc.ca/chic-ccdh/Research_Reports-Rapports_de_recherche/eng_bilingual/Molds in Finished Basements.pdf" onclick="window.open(this.href,'_blank');return false;">
                Click here to read the full report.</a></p>
            </div>
        `
        },
      {
        title: "Rising Damp",
        body: `
                    <div class="page_article">
                        <p>Rising damp is the wicking of water through the footing, into the concrete wall, and its 
                        evaporation inside the building. Rising damp increases the relative humidity on the inside face 
                        of the concrete which leads to mold growth as reported in the CMHC report.</p>
                        <p>Rising damp does not produce pools of water (as with liquid water entering a concrete wall), but 
                        rather a chronic musty smell, growing insidiously stronger when the footing is exposed to more moisture.</p>
                        <p>The worst case of rising damp occurs when water ponding occurs at  the footing level. This 
                        occurs over impervious soils where the excavation is inadequately sloped, the drain tiles are not 
                        located below the bottom of the footing, and no sub-footing drainage layer was installed.</p>
                        <p>Even without water ponding, rising damp ccurs when unprotected footings are exposed to damp 
                        ground. &#39;Hygroscopic&#39; concrete wicks ground moisture up into the foundation concrete which 
                        is then evaporated inside the building. Fastfoot<sup>®</sup> prevents this wicking from occurring, providing 
                        a drier and healthier indoor environment.</p>
                        <p><a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Click here for the use of Fastfoot<sup>®</sup> to prevent rising damp.</a></p>
                    </div>
                `,
        image: "/images/rising-damp.webp",
      },
      {
        title: "",
        body: `
                    <div class="page_article">
                        <h3>Chris Mattock, Habitat Design & Consulting Ltd.</h3>
                        <p>Chris Mattock, Principal Consultant with <a href="https://www.hdplusc.com" onclick="window.open(this.href,'_blank');return false;">
                        Habitat Design & Consulting</a>, sees substantial benefits in footing membranes:</p>
                        <p><em>&quot;It makes no sense that builders spend time and money damp proofing the exterior of 
                        their foundations walls, yet leave the concrete footings standing in a pool of water. 
                        As water vapour always travels from high to low humidity, ultimately this moisture will get drawn 
                        inside the building.&quot;</em></p>
                    </div>
                `,
        image: "/images/mattock-mug.webp",
      },
    ],
  },
  {
    id: "foldedCorners",
    menuItem: {
      en: {
        url: urls.fastFoot.residential.foldedCorners,
        title: `Folded Corners"`,
        metaTitle: "Folded Corners Installation Guide | Fab-Form",
        metaDescription: "Learn how to cut and fold Fastfoot® fabric to create corners. Step-by-step instructions with images for proper installation and corner folding.",
      },
    },
    category: "none",
    images: [],
    videos: [],
    body: `
            <div>
                <p>Fab-Form now offers<a href=${urls.fastFoot.residential.sewnCorner}> sewn corners</a> for the same lineal price as the fabric 
                roll. If sewn corners are not available, corners can be cut and folded as shown below:</p>  
            </div>
        `,
    articles: [
      {
        title: "Step I",
        body: `
                    <div class="page_article">
                        <p>Run Fastfoot past corner. Nail off center line and corner diagonal. Staple fabric in position 
                        up to corner.</p>
                        <p>Cut an inverted &#39;T&#39; on inside fabric as shown. Run top of &#39;T&#39; the full 
                        footing width in one direction, and an equivalent width in the opposite direction. Staple tab #1 
                        to screed board #1.</p>
                    </div>
                `,
        image: "/images/corner1.webp",
      },
      {
        title: "Step II",
        body: `
                    <div class="page_article">
                        <p>Lift fabric up at point &quot;F&quot;, pivoting roll around outside corner until aligned in 
                        new direction.</p>
                    </div>
                `,
        image: "/images/corner2.webp",
      },
      {
        title: "Step III",
        body: `
                    <div class="page_article">
                        <p>Lay down fold &quot;F&quot; and nail to ground. Staple tab #2 to screed board. Corner finished.</p>
                    </div>
                `,
        image: "/images/corner3.webp",
      },
    ],
  },
  {
    id: "world-of-concrete",
    menuItem: {
      en: {
        url: "world-of-concrete",
        title: `Fab-Form Industries - World of Concrete 2025`,
        metaTitle: "Fab-Form Industries at World of Concrete 2025 | Booth N568",
        metaDescription: "Join Fab-Form Industries at World of Concrete 2025 in Las Vegas! Discover our latest innovations, including the Fast-Tube Vertical Column Form. Visit us at Booth N568, January 21-23, 2025.",
      },
    },
    category: "none",
    images: [],
    videos: [],
    body: "",
    articles: [
        {
            body: `<div>
            <p>We are thrilled to announce that Fab-Form Industries will be participating in the World of Concrete 2024, the industry’s largest annual international event dedicated to concrete and masonry professionals.</p>
            <p>Event Details:
                <ul>
                    <li>Dates: January 21-23, 2025</li>
                    <li>Location: Las Vegas Convention Center, Las Vegas, NV</li>
                    <li>Booth: <a href="https://ge25woc.mapyourshow.com/8_0/floorplan/?hallID=A&selectedBooth=N568" rel="noreferrer">N568</a></li>
                </ul>
            </p>
            <p>Join us at our booth to discover our latest innovations in concrete formwork and learn more about our product lines, including the Fast-Tube Vertical Column Form and other sustainable solutions for the construction industry.</p>
            <p>What to Expect:
                <ul>
                    <li>Product Demos: Get hands-on experience with our new products and see how they can enhance your project efficiency.</li>
                    <li>Expert Talks: Engage with our team of professionals to gain insights into the latest industry trends and best practices.</li>
                    <li>Networking Opportunities: Connect with fellow professionals and explore collaborative opportunities.</li>
                </ul>
            </p>
            <p>Don’t Miss Out! Visit us at Booth N568 to see how Fab-Form is reshaping the future of concrete construction. For more information about the event, visit <a href="https://www.worldofconcrete.com/en/home.html" rel="noreferrer">World Of Concrete</a></p>
            <p>We look forward to seeing you there!</p>
        </div>`
        }
    ],
  },
  {
    id: "privacy-policy",
    menuItem: {
      en: {
        url: "privacy-policy",
        title: `Fab-Form Industries - Privacy Policy`,
        metaTitle: "Fab-Form Industries Privacy Policy | Your Privacy Rights and Data Usage",
        metaDescription: "Read Fab-Form Industries' Privacy Policy to understand how we collect, use, and protect your personal data. Learn about your privacy rights and our data processing practices.",
      },
    },
    category: "none",
    images: [],
    videos: [],
    body: "",
    
    articles: [
        {
            body: `<div data-custom-class="body">
            <div>
                <span style="font-size: 26px; ">PRIVACY POLICY</span>
			</div>
            <div>Last updated June 14, 2024</div>
			<div><br></div>
			<div>
				<span>This privacy notice for Fab-Form Industries LLC. ("we," "us," or "our"</span>
				<span>), describes how and why we might collect, store, use your information when you use our services ("Services"), such as when you:</span>
			</div>
			<ul class="disc-list">
				<li>Visit our website at <a href="https://fab-form.com/" target="_blank" data-custom-class="link">https://fab-form.com/</a>, or any website of ours that links to this privacy notice</li>
                <li>Engage with us in other related ways, including any sales, marketing, or events</li>
			</ul>
            <div><br></div>
			
            <div>Questions or concerns?&nbsp;Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at info@fab-form.com.</div>
            <div><br></div>

            <div>SUMMARY OF KEY POINTS</div>
            <div><br></div>
                
            <div>
                <em>This summary provides key points from our privacy notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our&nbsp;</em>
                <a data-custom-class="link" href="#toc"><em>table of contents</em></a>
                <em>&nbsp;below to find the section you are looking for.</em>
            </div>
            <div><br></div>
                
            <div>What personal information do we process? When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more about&nbsp;
                <a data-custom-class="link" href="#personalinfo">personal information you disclose to us</a>.
            </div>
            <div><br></div>
                
            <div>Do we process any sensitive personal information? We do not process sensitive personal information.</div>
            <div><br></div>
                
            <div>Do we collect any information from third parties? We do not collect any information from third parties.</div>
            <div><br></div>

            <div>How do we process your information? We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so.
                <a data-custom-class="link" href="#infouse">how we process your information</a>.
            </div>
            <div><br></div>
                
            <div>How do we keep your information safe? We have organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.
                <a data-custom-class="link" href="#infosafe">how we keep your information safe</a>.
            </div>
            <div><br></div>

            <div>What are your rights? Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information.
                <a data-custom-class="link" href="#privacyrights">your privacy rights</a>.
            </div>
            <div><br></div>

            <div>How do you exercise your rights? The easiest way to exercise your rights is by submitting a data subject access request, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.</div>
            <div><br></div>

            <div>Want to learn more about what we do with any information we collect?&nbsp;
                <a data-custom-class="link" href="#toc">Review the privacy notice in full</a>.
            </div>
            <div><br></div>

            <div id="toc">
                <span>TABLE OF CONTENTS</span>
            </div>
            <div><br></div>
                
            <div><a class="pp-link" href="#infocollect">1. WHAT INFORMATION DO WE COLLECT?</a></div>
            <div><a class="pp-link" href="#infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</a></div>
            <div><a class="pp-link" href="#legalbases">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?</a></div>
            <div><a class="pp-link" href="#whoshare">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</a></div>
            <div><a class="pp-link" href="#cookies">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</a></div>
            <div><a class="pp-link" href="#intltransfers">6. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?</a></div>
            <div><a class="pp-link" href="#inforetain">7. HOW LONG DO WE KEEP YOUR INFORMATION?</a></div>
            <div><a class="pp-link" href="#infosafe">8. HOW DO WE KEEP YOUR INFORMATION SAFE?</a></div>
            <div><a class="pp-link" href="#infominors">9. DO WE COLLECT INFORMATION FROM MINORS?</a></div>
            <div><a class="pp-link" href="#privacyrights">10. WHAT ARE YOUR PRIVACY RIGHTS?</a></div>
            <div><a class="pp-link" href="#DNT">11. CONTROLS FOR DO-NOT-TRACK FEATURES</a></div>
            <div><a class="pp-link" href="#uslaws">12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</a></div>
            <div><a class="pp-link" href="#policyupdates">13. DO WE MAKE UPDATES TO THIS NOTICE?</a></div>
            <div><a class="pp-link" href="#contact">14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a></div>
            <div><a class="pp-link" href="#request">15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</a></div>
			<div><br></div>

            <div id="infocollect">1. WHAT INFORMATION DO WE COLLECT?</div>
            <div><br></div>

            <div id="personalinfo">Personal information you disclose to us</div>
            <div><br></div>

            <div>In Short: We collect personal information that you provide to us.</em><</div>
            <div><br></div>
                
            <div>We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</div>
            <div><br></div>
                
            <div>Personal Information Provided by You. The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:</div>
                
            <ul class="disc-list">
                <li>names</li>
                <li>phone numbers</li>
                <li>email addresses</li>
                <li>mailing addresses</li>
                <li>billing addresses</li>
            </ul>
            <div><br></div>
                
            <div id="sensitiveinfo">Sensitive Information. We do not process sensitive information.</div>
            <div><br></div>
                
            <div>All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</div>
            <div><br></div>
                
            <div>
                    <span>
                    <span>Information automatically collected</span>
                </span>
            </div>
            <div><div><br>
            
            <div><em>In Short: Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our Services.</em></div>
            <div><br></div>
        
            <div>We automatically collect certain information when you visit, use, or navigate the Services. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when you use our Services, and other technical information. This information is primarily needed to maintain the security and operation of our Services, and for our internal analytics and reporting purposes.</div>
            <div><br></div>
            
            <div>Like many businesses, we also collect information through cookies and similar technologies.</div>
            <div><br></div>
            
            <div>The information we collect includes:</div>
            
            <ul class="disc-list">
                <li><em>Log and Usage Data.</em> Log and usage data is service-related, diagnostic, usage, and performance information our servers automatically collect when you access or use our Services and which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type, and settings and information about your activity in the Services (such as the date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called "crash dumps"), and hardware settings).</li>
                <li><em>Device Data.</em> We collect device data such as information about your computer, phone, tablet, or other device you use to access the Services. Depending on the device used, this device data may include information such as your IP address (or proxy server), device and application identification numbers, location, browser type, hardware model, Internet service provider and/or mobile carrier, operating system, and system configuration information.</li>
                <li><em>Location Data.</em> We collect location data such as information about your device's location, which can be either precise or imprecise. How much information we collect depends on the type and settings of the device you use to access the Services. For example, we may use GPS and other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of allowing us to collect this information either by refusing access to the information or by disabling your Location setting on your device. However, if you choose to opt out, you may not be able to use certain aspects of the Services.</li>
            </ul>
            <div><br></div>
            
            <div id="infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</div>
            <div><br></div>

            <div>We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent</div>
            <div><br></div>
            
            <div id="legalbases">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</div>
            <div><br></div>

            <div>
                <div>
                    <div>
                        <em>In Short: We only process your personal information when we believe it is necessary and we have a valid legal reason (i.e., legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide you with services to enter into or fulfill our contractual obligations, to protect your rights, or to fulfill our legitimate business interests.</em>
                       </div>
                    <div><br></div>
                    
                    <div>
                        <u>
                            <em>If you are located in Canada, this section applies to you.</em>
                        </u>
                    </div>
                    <div><br></div>
                    
                    <div>We may process your information if you have given us specific permission (i.e., express consent) to use your personal information for a specific purpose, or in situations where your permission can be inferred (i.e., implied consent). You can&nbsp;
                        <a data-custom-class="link" href="#withdrawconsent">withdraw your consent</a>&nbsp;at any time.
                    </div>
                    <div><br></div>
                    
                    <div>In some exceptional cases, we may be legally permitted under applicable law to process your information without your consent, including, for example:</div>
                    
                    <ul class="disc-list">
                        <li>If collection is clearly in the interests of an individual and consent cannot be obtained in a timely way</li>
                        <li>For investigations and fraud detection and prevention</li>
                        <li>For business transactions provided certain conditions are met</li>
                        <li>If it is contained in a witness statement and the collection is necessary to assess, process, or settle an insurance claim</li>
                        <li>For identifying injured, ill, or deceased persons and communicating with next of kin</li>
                        <li>If we have reasonable grounds to believe an individual has been, is, or may be victim of financial abuse</li>
                        <li>If it is reasonable to expect collection and use with consent would compromise the availability or the accuracy of the information and the collection is reasonable for purposes related to investigating a breach of an agreement or a contravention of the laws of Canada or a province</li>
                        <li>If disclosure is required to comply with a subpoena, warrant, court order, or rules of the court relating to the production of records</li>
                        <li>If it was produced by an individual in the course of their employment, business, or profession and the collection is consistent with the purposes for which the information was produced</li>
                        <li>If the collection is solely for journalistic, artistic, or literary purposes</li>
                        <li>If the information is publicly available and is specified by the regulations</li>
                    </ul>
                <div>
            </div>
            <div><br></div>
                
            <div id="whoshare">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</div>
			<div><br></div>
			
            <div>We don't share any personal information with third parties.</div>
			<div><br></div>
				
            <div id="cookies">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</div>
            <div><br></div>
            
            <div><em>In Short: We may use cookies and other tracking technologies to collect and store your information.</em></div>
            <div><br></div>
            
            <div>We may use cookies and similar tracking technologies (like web beacons and pixels) to gather information when you interact with our Services. Some online tracking technologies help us maintain the security of our Services, prevent crashes, fix bugs, save your preferences, and assist with basic site functions.</div>
            <div><br></div>
            
            <div>We also permit third parties and service providers to use online tracking technologies on our Services for analytics and advertising, including to help manage and display advertisements, to tailor advertisements to your interests, or to send abandoned shopping cart reminders (depending on your communication preferences). The third parties and service providers use their technology to provide advertising about products and services tailored to your interests which may appear either on our Services or on other websites.</div>
            <div><br></div>
            
            <div>To the extent these online tracking technologies are deemed to be a "sale"/"sharing" (which includes targeted advertising, as defined under the applicable laws) under applicable US state laws, you can opt out of these online tracking technologies by submitting a request as described below under section "<a data-custom-class="link" href="#uslaws">DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</a>".</div>
            <div><br></div>
            
            <div>Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.</div>
			<div><br></div>

			<div id="intltransfers"><span>6. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY? </span></div>
            <div><br></div>
            
            <div><em>In Short: We may transfer, store, and process your information in countries other than your own.</em></div>
            <div><br></div>
            
            <div>Our servers are located in Canada and the US. If you are accessing our Services from outside, please be aware that your information may be transferred to, stored, and processed by us in our facilities. If you are a resident in the European Economic Area (EEA), United Kingdom (UK), or Switzerland, then these countries may not necessarily have data protection laws or other similar laws as comprehensive as those in your country. However, we will take all necessary measures to protect your personal information in accordance with this privacy notice and applicable law.</div>              
            <div><br></div>
				
			<div id="inforetain">7. HOW LONG DO WE KEEP YOUR INFORMATION?</div>
            <div><br></div>
            
            <div><em>In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.</em></div>
            <div><br></div>
            
            <div>We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).</div>
            <div><br></div>
            
            <div>When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.</div>
            <div><br></div>
            
            
            <div id="infosafe">8. HOW DO WE KEEP YOUR INFORMATION SAFE?</div>
            <div><br></div>
            
            <div><em>In Short: We aim to protect your personal information through a system of organizational and technical security measures.</em></div>
            <div><br></div>
            
            <div>We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.</div>
            <div><br></div>
            
            <div id="infominors">9. DO WE COLLECT INFORMATION FROM MINORS?</div>
            <div><br></div>
            
            <div><em>In Short:</em><em>&nbsp;We do not knowingly collect data from or market to children under 18 years of age.</em></div>
            <div><br></div>
            
            <div>We do not knowingly collect, solicit data from, or market to children under 18 years of age, nor do we knowingly sell such personal information. By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at info@fab-form.com.</div>
            <div><br></div>
            
            <div id="privacyrights">10. WHAT ARE YOUR PRIVACY RIGHTS?</div>
            <div><br></div>
            
            <div><em>In Short: Depending on your state of residence in the US or in some regions, such as, you have rights that allow you greater access to and control over your personal information. You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.</em></div>
            <div><br></div>
            
            <div>In some regions (like), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; (iv) if applicable, to data portability; and (v) not to be subject to automated decision-making. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us by using the contact details provided in the section "<a class="pp-link" href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>" below.</div>
            <div><br></div>
            
            <div>We will consider and act upon any request in accordance with applicable data protection laws.</div>
            <div><br></div>
            
            <div id="withdrawconsent"><u>Withdrawing your consent:</u> If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section "<a class="pp-link" href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>" below.</div>
            <div><br></div>
                            
            <div>However, please note that this will not affect the lawfulness of the processing before its withdrawal nor, when applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.</div>
            <div><br></div>
                
            <div><u>Opting out of marketing and promotional communications:</u>&nbsp;You can unsubscribe from our marketing and promotional communications at any time by clicking on the unsubscribe link in the emails that we send, replying "STOP" or "UNSUBSCRIBE" to the SMS messages that we send, or by contacting us using the details provided in the section "</span></span><a data-custom-class="link" href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>" below. You will then be removed from the marketing lists. However, we may still communicate with you — for example, to send you service-related messages that are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes.</div>
            <div><br></div>
            
            <div>If you have questions or comments about your privacy rights, you may email us at info@fab-form.com.</div>
            <div><br></div>
            
            
            <div id="DNT">11. CONTROLS FOR DO-NOT-TRACK FEATURES</div>
            <div><br></div>
            
            <div>Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.</div>
            <div><br></div>
                        
            <div>California law requires us to let you know how we respond to web browser DNT signals. Because there currently is not an industry or legal standard for recognizing or honoring DNT signals, we do not respond to them at this time.</div>
            <div><br></div>
            
            <div id="uslaws">12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</div>
            <div><br></div>
            
            <div><em>In Short: If you are a resident of California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Montana, New Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia, you may have the right to request access to and receive details about the personal information we maintain about you and how we have processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. More information is provided below.</em></div>
            <div><br></div>
            
            <div>Categories of Personal Information We Collect</div>
            <div><br></div>
            
            <div>We have collected the following categories of personal information in the past twelve (12) months.</div>
            <div><br></div>
            
            <table style="width: 100%;">
                <tbody>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">Category</td>
                        <td style="width: 51.4385%; border-top: 1px solid white; border-right: 1px solid white;">Examples</td>
                        <td style="width: 14.9084%; border-right: 1px solid white; border-top: 1px solid white; text-align: center;">Collected</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">A. Identifiers</td>
                        <td style="width: 51.4385%; border-top: 1px solid white; border-right: 1px solid white;">Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal identifier, online identifier, Internet Protocol address, email address, and account name</td>
                        <td style="width: 14.9084%; text-align: center; vertical-align: middle; border-right: 1px solid white; border-top: 1px solid white;">YES</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">B. Personal information as defined in the California Customer Records statute</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Name, contact information, education, employment, employment history, and financial information</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">YES</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">C. Protected classification characteristics under state or federal law</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Gender, age, date of birth, race and ethnicity, national origin, marital status, and other demographic data</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">YES</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">D. Commercial information</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Transaction information, purchase history, financial details, and payment information</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">YES</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">E. Biometric information</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Fingerprints and voiceprints</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">NO</td></tr><tr><td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;"><div>F. Internet or other similar network activity</div></td><td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;"><div>Browsing history, search history, online behavior, interest data, and interactions with our and other websites, applications, systems, and advertisements</div></td><td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">NO</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">G. Geolocation data</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Device location</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">NO</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">H. Audio, electronic, sensory, or similar information</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Images and audio, video or call recordings created in connection with our business activities</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">NO</td>
                    </tr>
                    <tr>
                        <td style="width: 33.8274%; border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white;">I. Professional or employment-related information</td>
                        <td style="width: 51.4385%; border-right: 1px solid white; border-top: 1px solid white;">Business contact details in order to provide you our Services at a business level or job title, work history, and professional qualifications if you apply for a job with us</td>
                        <td style="width: 14.9084%; text-align: center; border-right: 1px solid white; border-top: 1px solid white;">NO</td>
                    </tr>
                    <tr>
                        <td style="border-left: 1px solid white; border-right: 1px solid white; border-top: 1px solid white; width: 33.8274%;">J. Education Information</td>
                        <td style="border-right: 1px solid white; border-top: 1px solid white; width: 51.4385%;">Student records and directory information</td>
                        <td style="text-align: center; border-right: 1px solid white; border-top: 1px solid white; width: 14.9084%;">NO</td>
                    </tr>
                    <tr>
                        <td style="border-width: 1px; border-color: white; border-style: solid; width: 33.8274%;">K. Inferences drawn from collected personal information</td>
                        <td style="border-bottom: 1px solid white; border-top: 1px solid white; border-right: 1px solid white; width: 51.4385%;">Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual’s preferences and characteristics</td>
                        <td style="text-align: center; border-right: 1px solid white; border-bottom: 1px solid white; border-top: 1px solid white; width: 14.9084%;">NO</td>
                    </tr>
                    <tr>
                        <td>L. Sensitive personal Information</td>
                        <td style="border-right: 1px solid white; border-bottom: 1px solid white; line-height: 1.5;"></td>
                        <td style="border-right: 1px solid white; border-bottom: 1px solid white;">NO</td>
                    </tr>
                </tbody>
            </table>
            <div><br></div>
            
            <div>We may also collect other personal information outside of these categories through instances where you interact with us in person, online, or by phone or mail in the context of:</div>
            <ul class="disc-list">
                <li>Receiving help through our customer support channels;</li>
                <li>Participation in customer surveys or contests; and</li>
                <li>Facilitation in the delivery of our Services and to respond to your inquiries.</li>
            </ul>
            <div><br></div>
            
            <div>We will use and retain the collected personal information as needed to provide the Services or for:</div>
            <ul class="disc-list">
                <li>Category A - As long as the user has an account with us</li>
                <li>Category B - As long as the user has an account with us</li>
                <li>Category C - As long as the user has an account with us</li>
                <li>Category D - As long as the user has an account with us</li>
            </ul>
            <div><br></div>
            
            <div>Sources of Personal Information</div>
            <div><br></div>
                                            
            <div>Learn more about the sources of personal information we collect in "<a class="pp-link" href="#infocollect">WHAT INFORMATION DO WE COLLECT?</a>"</div>
            <div><br></div>
            
            <div>How We Use Personal Information</div>
            <div><br></div>
            
            <div>Learn about how we use your personal information in the section, "<a data-custom-class="link" href="#infouse">HOW DO WE PROCESS YOUR INFORMATION?</a>"</div>
            <div><br></div>
            
            <div>We collect your personal information through:</div>
            <ul class="disc-list">
                <li>Targeting cookies/Marketing cookies</li>
                <li>Social media cookies</li>
                <li>Beacons/Pixels/Tags</li>
            </ul>
            <div><br></div>

            <div>We may use your personal information for our own business purposes, such as for undertaking internal research for technological development and demonstration. This is not considered to be "selling" of your personal information.</div>
            <div><br></div>
            
            <div>We have not sold or shared any personal information to third parties for a business or commercial purpose in the preceding twelve (12) months.&nbsp;We have disclosed the following categories of personal information to third parties for a business or commercial purpose in the preceding twelve (12) months:</div>
            <div><br></div>
            
            <div>Your Rights</div>
            <div><br></div>
            
            <div>You have rights under certain US state data protection laws. However, these rights are not absolute, and in certain cases, we may decline your request as permitted by law. These rights include:</div>
            <ul class="disc-list">
                <li>Right to know whether or not we are processing your personal data</li>
                <li>Right to access&nbsp;your personal data</li>
                <li>Right to correct&nbsp;inaccuracies in your personal data</li>
                <li>Right to request the deletion of your personal data</li>
                <li>Right to obtain a copy&nbsp;of the personal data you previously shared with us</li>
                <li>Right to non-discrimination for exercising your rights</li>
                <li>Right to opt out of the processing of your personal data if it is used for targeted advertising (or sharing as defined under California’s privacy law), the sale of personal data, or profiling in furtherance of decisions that produce legal or similarly significant effects ("profiling")</li>
            </ul>
            <div><br></div>

            <div>Depending upon the state where you live, you may also have the following rights:</div>
            <ul class="disc-list">
                <li>Right to obtain a list of the categories of third parties to which we have disclosed personal data (as permitted by applicable law, including California's and Delaware's privacy law)</li>
                <li>Right to obtain a list of specific third parties to which we have disclosed personal data (as permitted by applicable law, including Oregon’s privacy law)</li>
                <li>Right to limit use and disclosure of sensitive personal data (as permitted by applicable law, including California’s privacy law)</li>
                <li>Right to opt out of the collection of sensitive data and personal data collected through the operation of a voice or facial recognition feature (as permitted by applicable law, including Florida’s privacy law)</li>
            </ul>
            <div><br></div>
            
            <div>How to Exercise Your Rights</div>
            <div><br></div>
            
            <div>To exercise these rights, you can contact us data subject access request, by emailing us at info@fab-form.com, by calling toll-free at +1-888-303-3278, by visiting <a class="pp-link" href="https://fab-form.com/contactUs.php" target="_blank">https://fab-form.com/contactUs.php</a>, or by referring to the contact details at the bottom of this document.</div>
            <div><br></div>
            
            <div>We will honor your opt-out preferences if you enact the&nbsp;<a data-custom-class="link" href="https://globalprivacycontrol.org/" rel="noopener noreferrer" target="_blank">Global Privacy Control</a>&nbsp;(GPC) opt-out signal on your browser.</div>
            <div><br></div>
            
            <div>Under certain US state data protection laws, you can designate an authorized agent to make a request on your behalf. We may deny a request from an authorized agent that does not submit proof that they have been validly authorized to act on your behalf in accordance with applicable laws.</div>
            <div><br></div>
            
            <div>Request Verification</div>
            <div><br></div>
            
            <div>Upon receiving your request, we will need to verify your identity to determine you are the same person about whom we have the information in our system. We will only use personal information provided in your request to verify your identity or authority to make the request. However, if we cannot verify your identity from the information already maintained by us, we may request that you provide additional information for the purposes of verifying your identity and for security or fraud-prevention purposes.</div>
            <div><br></div>
            
            <div>If you submit the request through an authorized agent, we may need to collect additional information to verify your identity before processing your request and the agent will need to provide a written and signed permission from you to submit such request on your behalf.</div>
            <div><br></div>
            
            <div>Appeals</div>
            <div><br></div>
            
            <div>Under certain US state data protection laws, if we decline to take action regarding your request, you may appeal our decision by emailing us at info@fab-form.com. We will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If your appeal is denied, you may submit a complaint to your state attorney general.</div>
			<div><br></div>

			<div id="policyupdates">13. DO WE MAKE UPDATES TO THIS NOTICE?</div>
            <div><br></div>
            
            <div><em>In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.</em></div>
            <div><br></div>
            
            <div>We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date at the top of this privacy notice. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.</div>
            <div><br></div>
            
            <div id="contact">14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</div>
            <div><br></div>
            
            <div>If you have questions or comments about this notice, you may email us at info@fab-form.com or&nbsp;contact us by post at:</div>
            <div><br></div>
            
            <div>Fab-Form Industries LLC.</div>
            <div>1610 Derwent Wy</div>
            <div>Unit 19</div><div>Delta, British Columbia V3M 6W1</div>
            <div>Canada</div>
            <div><br></div>
            
            <div id="request">15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</div>
            <div><br></div>
            
            <div>Based on the applicable laws of your country or state of residence in the US, you may have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. To request to review, update, or delete your personal information, please data subject access request.</div>
        </div>`
        }
    ],
  },

];